import { SetStateAction, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { AuthContext, useAuth } from 'context/AuthContext';
import { format, utcToZonedTime } from 'date-fns-tz';

import ArticlePlaceholder from 'components/ui/article-placeholder';

import { RiArrowLeftSLine } from 'react-icons/ri';
import { TfiMedallAlt } from 'react-icons/tfi';
import { PiThumbsUpLight, PiHandsClappingLight } from 'react-icons/pi';
import { FaRegGrinStars } from 'react-icons/fa';
import {
  deleteFeedbackByQuery,
  getPlayerInfo,
  getServerTime,
  getTasksManager,
  playerLastManager,
  updateTask,
  getNextManagers,
  verifyBonus,
} from 'services/dashboard.service';

import { TaskItem } from 'components/task-item';
import { Countdown } from 'components/countdown';
import { clamp, getFutureCalendar, getMonthNameFromString, getTaskStep } from 'utils/helpers';
import { CheckManagerType, GetTaskLevelLabel } from 'utils/strings';
import { BiMinus, BiUpvote } from 'react-icons/bi';
import { FaCoins } from 'react-icons/fa';
import { actionLog } from 'services/actionlog.service';
import Box from 'components/ui/box';
import { useModal } from 'context/ModalContext';
import { HiOutlineHandThumbDown, HiOutlineHandThumbUp } from 'react-icons/hi2';
import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import { Step, User } from 'types/user';
import { getStorageItem } from 'utils/storage';
import { UserAvatar } from 'components/user-avatar';
import { BsChatText, BsPlusLg } from 'react-icons/bs';
import CustomSelect from 'components/custom-select';
import Detail from 'pages/MissaoDestaque/Detail';
import Header from '../components/Header';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { subMinutes } from 'date-fns';
import { findLateralMenagers } from 'services/profile.service';
import SelectGestor from '../components/SelectGestor';
import ModalCod5 from '../components/ModalCod5';
import CardPlus from '../components/CardPlus';

import CardIcon from 'assets/img/cards-icon.svg';
import { NotFound } from 'pages/NotFound';
import { GetVersion } from 'services/utils';
import { ExportButton } from 'components/generate-xcel';

export function ApreciarRealizacao() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const { showModal } = useModal();
  const { user, cyclesExtended, realCycle, cycleSelected, setCycleSelected, userInfo } = useAuth();

  const [realDatetime, setRealDatetime] = useState<number>(0);

  const [internalUser, setInternalUser] = useState<User>();

  const [pageLoading, setPageLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [gestor, setIsGestor] = useState(false);
  const [data, setData] = useState<any[]>();

  const [filteredData, setFilteredData] = useState<any[]>();
  const [tasksByFilter, setTasksByFilter] = useState<any[]>();

  const [validTasks, setValidTasks] = useState<unknown[]>([]);
  const [rejectedTasks, setRejectedTasks] = useState<unknown[]>([]);
  const [doubledTasks, setDoubledTasks] = useState<unknown[]>([]);
  const [promotedTasks, setPromotedTasks] = useState<unknown[]>([]);
  const [feedbackTasks, setFeedbackTasks] = useState<number | undefined>();
  const [valeuTasks, setValeuTasks] = useState<any[]>();
  const [mandouBemTasks, setMandouBemTasks] = useState<any[]>();
  const [uauTasks, setUauTasks] = useState<any[]>();

  const [maxValidTasks, setMaxValidTasks] = useState(0);
  const [maxRejectedTasks, setMaxRejectedTasks] = useState(0);
  const [maxDoubledTasks, setMaxDoubledTasks] = useState(0);
  const [maxPromotedTasks, setMaxPromotedTasks] = useState(0);
  const [maxValeuTasks, setMaxValeuTasks] = useState(0);
  const [maxMandouBemTasks, setMaxMandouBemTasks] = useState(0);
  const [maxUauTasks, setMaxUauTasks] = useState(0);

  const [activeTabDirector, setActiveTabDirector] = useState<'diretoria' | 'rede' | 'mad'>('diretoria');

  const [playerInfo, setPlayerInfo] = useState<any>();

  const [stages, setStages] = useState<Step[] | undefined>([]);
  const [currentCycle, setCurrentCycle] = useState<string | undefined>();
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);
  const [activeCycleSelected, setActiveCycleSelected] = useState<any>();
  const [currentStage, setCurrentStage] = useState<string | undefined>();
  const [elementsIndexOf, setElementsIndexOf] = useState<number>();
  const [numberOfElements, setNumberOfElements] = useState(3);
  const [showMore, setShowMore] = useState(false);
  const [calendarElementsIndexOf, setCalendarElementsIndexOf] = useState<number>(5);
  const [calendarNumberOfElements, setCalendarNumberOfElements] = useState(5);
  const [calendarShowMore, setCalendarShowMore] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedGestor, setSelectedGestor] = useState<any>();
  const [functionGestor, setFunctionGestor] = useState<string>('');
  const [getAction, setGetAction] = useState<any>(false);
  const [modalCod5, setModalCod5] = useState<any>(undefined);
  const [bonus, setBonus] = useState<any>(undefined);
  const [loadBonus, setLoadBonus] = useState(true);
  const [hasTime, setHasTime] = useState(false);
  const [tasksStatus, setTasksStatus] = useState<string[]>([]);
  const [selectedtasksStatus, setSelectedTasksStatus] = useState<string>();
  const [searchText, setSearchText] = useState<string>();

  const [pairSelected, setPairSelected] = useState<string | undefined>();

  useEffect(() => {
    // let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);
      setHasTime(true);

      // interv = window.setInterval(() => {
      //   setRealDatetime(prevstate => prevstate + 1000);
      // }, 1000);
    });

    // return () => clearInterval(interv);
  }, []);

  const isVacationManager = useMemo(() => !!internalUser && !!user && internalUser._id !== user._id, [internalUser, user]);

  const isDirectManager = useMemo(
    () =>
      isVacationManager &&
      userInfo &&
      playerInfo &&
      (userInfo?._id === playerInfo?.gestor ||
        (Array.isArray(userInfo?.mad_dupla) && userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor))),
    [isVacationManager, playerInfo, userInfo],
  );

  // const activeStageObj = useMemo(
  //   () => (Array.isArray(stages) && !!currentStage ? stages.find(x => x._id === currentStage) : undefined),
  //   [currentStage, stages],
  // );

  function calcPoints(multiplicador: number, status: string, stageNumber: number) {
    if (
      typeof multiplicador !== 'number' ||
      multiplicador <= 0 ||
      typeof status !== 'string' ||
      typeof stageNumber !== 'number' ||
      stageNumber < 1 ||
      stageNumber > 3
    ) {
      return 0;
    }

    let adicional = 0;

    if (
      ((status === 'promovido' || status === 'concluido') &&
        ((stageNumber === 2 && multiplicador === 2) || (stageNumber === 3 && multiplicador === 4))) ||
      (stageNumber === 3 && multiplicador === 8)
    ) {
      adicional = 100;
    }

    if (stageNumber === 3 && multiplicador === 16) {
      adicional = 200;
    }

    return multiplicador * 300 + adicional;
  }

  const activeStageObj = useMemo(() => {
    if (!Array.isArray(stages) || !currentStage) return undefined;

    // if (currentStage === 'semestral') {
    //   const cycle = realCycle?.find(x => x._id === activeCycleSelected);

    //   const evaluationStage = stages.find(x => x.status === 'evaluation') || stages[0];
    //   if (!evaluationStage || !cycle?.date_start || !cycle?.date_end) return undefined;

    //   const _stages = {
    //     ...evaluationStage,
    //     title: 'Semestral',
    //     date_start: cycle?.date_start,
    //     date_finish: cycle?.date_end,
    //     step: 5,
    //     // taskStep >= 5 getTaskStep
    //   };

    //   return _stages;
    // }

    // if (currentStage === 'trimestral') {
    //   const evaluationStage = stages.find(x => x.status === 'evaluation') || stages[0];
    //   if (!evaluationStage || !evaluationStage?.date_trimester_start || !evaluationStage?.date_trimester_finish) return undefined;

    //   const _stages = {
    //     ...evaluationStage,
    //     title: 'Trimestral',
    //     date_start: evaluationStage?.date_trimester_start,
    //     date_finish: evaluationStage?.date_trimester_finish,
    //     step: 4,
    //     // taskStep >= 4 getTaskStep
    //   };

    //   return _stages;
    // }

    return stages.find(x => x._id === currentStage);
  }, [currentStage, stages]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!activeStageObj || !realDatetime) return null;

    if (realDatetime > activeStageObj.date_evaluation_step2_start && realDatetime < activeStageObj.date_evaluation_step2_finish) {
      // Etapa 2 - Validação, Nível 1 e Nível 2 Bonificação MAD
      return 2;
    } else if (
      realDatetime > activeStageObj.date_evaluation_step3_start &&
      realDatetime < activeStageObj.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > activeStageObj.date_evaluation_step4_start &&
      realDatetime < activeStageObj.date_evaluation_step4_finish
    ) {
      // Etapa 4 - Nível 2 e pit stop
      return 4;
    } else if (
      realDatetime > activeStageObj.date_evaluation_pitStop_start &&
      realDatetime < activeStageObj.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > activeStageObj.date_evaluation_step5_start &&
      realDatetime < activeStageObj.date_evaluation_step5_finish
    ) {
      // Etapa 5 - Nível 3
      return 5;
    } else {
      return 0;
    }
  }, [activeStageObj, realDatetime]);

  const userCodEtapa = useCallback(
    (userI?: any, verifyMad = false) => {
      if (!userI && !playerInfo) return undefined;

      const user = userI ?? playerInfo;

      const normalize = (val: number) => (typeof val === 'number' ? (val === 1 ? 3 : val > 5 ? 0 : val) : 0);

      const madCodEtapas =
        verifyMad && Array.isArray(user.mad_dupla)
          ? user.mad_dupla
              .map((m: any) => (typeof m.cod_etapa === 'number' ? normalize(m.cod_etapa) : null))
              .filter((v: any) => v !== null)
          : [];

      const maxMadCodEtapa = madCodEtapas.length > 0 ? Math.max(...madCodEtapas) : 0;

      const codEtapa =
        maxMadCodEtapa >
        (typeof user.cod_etapa === 'number' ? (user.cod_etapa === 1 ? 3 : user.cod_etapa > 5 ? 0 : user.cod_etapa) : 0)
          ? maxMadCodEtapa
          : typeof user.cod_etapa === 'number'
            ? user.cod_etapa
            : 0;

      const madCodEtapasSub =
        verifyMad && Array.isArray(user.mad_dupla)
          ? user.mad_dupla
              .map((m: any) => (typeof m.cod_etapa_sub === 'number' ? normalize(m.cod_etapa_sub) : null))
              .filter((v: any) => v !== null)
          : [];

      const maxMadCodEtapaSub = madCodEtapasSub.length > 0 ? Math.max(...madCodEtapasSub) : 0;

      const codEtapaSub =
        maxMadCodEtapaSub >
        (typeof user.cod_etapa_sub === 'number'
          ? user.cod_etapa_sub === 1
            ? 3
            : user.cod_etapa_sub > 5
              ? 0
              : user.cod_etapa_sub
          : 0)
          ? maxMadCodEtapaSub
          : typeof user.cod_etapa_sub === 'number'
            ? user.cod_etapa_sub
            : 0;

      return (!!user.mad || !!isVacationManager) && (codEtapaSub === 1 ? 3 : codEtapaSub) > (codEtapa === 1 ? 3 : codEtapa)
        ? codEtapaSub
        : codEtapa;
    },
    [isVacationManager, playerInfo],
  );

  // Retorna a etapa atual da missão
  // const getTaskStep = useCallback((task: any) => {
  //   if (!task || typeof task.status !== 'string') return undefined;

  //   // Etapa 2
  //   if (
  //     (task.status === 'rejeitado' || task.status === 'aguardando') &&
  //     (typeof task.stageNumber === 'undefined' || task.stageNumber === 0)
  //   ) {
  //     return 2;
  //   }

  //   // Se tiver Pit Stop
  //   if (typeof task.prosseguir_gst === 'string') {
  //     if (task.prosseguir_gst === 'next' || task.prosseguir_gst === 'stopped') {
  //       return 4.1;
  //     } else {
  //       return 5;
  //     }
  //   }

  //   // Etapa 3, 4 e 5
  //   if (typeof task.multiplicador === 'number') {
  //     if (typeof task.stageNumber === 'number') {
  //       if (task.stageNumber === 1) {
  //         return 3;
  //       } else if (task.stageNumber === 2) {
  //         return 4;
  //       } else if (task.stageNumber === 3) {
  //         return 5;
  //       }
  //     } else {
  //       // Etapa 3
  //       if (task.multiplicador === 1) {
  //         return 3;
  //       }

  //       // Etapa 3
  //       if (task.status === 'dobrado' && task.multiplicador === 2) {
  //         return 3;
  //       }

  //       // Etapa 4
  //       if (task.status === 'promovido' && task.multiplicador === 2) {
  //         return 4;
  //       }

  //       // Etapa 4
  //       if (task.status === 'dobrado' && task.multiplicador === 4) {
  //         return 4;
  //       }

  //       // Etapa 5
  //       if (task.status === 'promovido' && task.multiplicador === 4) {
  //         return 5;
  //       }

  //       // Etapa 5
  //       if (task.status === 'dobrado' && task.multiplicador === 8) {
  //         return 5;
  //       }

  //       // Etapa 5
  //       if (task.status === 'selo') {
  //         return 5;
  //       }
  //     }
  //   }

  //   return undefined;
  // }, []);

  const getPlayerStep = useCallback(
    (task: any) => {
      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) {
        return 4.1;
      }

      if (typeof userCodEtapa(null, !!task.mad) === 'number') {
        if (userCodEtapa(null, !!task.mad) === 2) {
          return 2;
        }

        if (userCodEtapa(null, !!task.mad) === 4) {
          if (
            String(task.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))
          ) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else if (
              typeof task.multiplicador === 'number' &&
              (task.multiplicador === 1 || (typeof task.stageNumber === 'number' && task.stageNumber === 1))
            ) {
              return 3;
            } else {
              return 4;
            }
          } else {
            return 4;
          }
        }

        if (userCodEtapa(null, !!task.mad) === 5) {
          if (
            String(task.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))
          ) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else if (typeof task.stageNumber === 'number' && task.stageNumber === 1) {
              return 3;
            } else if (typeof task.stageNumber === 'number' && task.stageNumber === 2) {
              return 4;
            } else {
              return 5;
            }
          } else {
            return 5;
          }
        }

        if (userCodEtapa(null, !!task.mad) === 1 || userCodEtapa(null, !!task.mad) === 3) {
          if (
            String(task.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))
          ) {
            if (task.status === 'rejeitado' || task.status === 'aguardando') {
              return 2;
            } else {
              return 3;
            }
          } else {
            return 3;
          }
        }

        return 0;
      }

      return 0;
    },
    [playerInfo?._id, playerInfo?.mad_dupla, userCodEtapa],
  );

  const getTaskStatuses: any = useCallback(
    (task: any) => {
      if (!task || !realCycle) return undefined;

      const statuses: any[] = [];

      const taskStep = getTaskStep(task);

      const stepTask = realCycle
        .find(x => task.created > x.date_start && task.created <= x.date_end)
        ?.steps.find(x => task.created > x.date_start && task.created <= x.date_finish);
      const actualTime = task.now;

      if (!stepTask || !taskStep) return undefined;

      function upsertStatus(newStatus: Record<string, string>) {
        const key = Object.keys(newStatus)[0];
        const index = statuses.findIndex((item: any) => Object.keys(item)[0] === key);

        if (index !== -1) {
          statuses[index] = newStatus;
        } else {
          statuses.push(newStatus);
        }
      }

      // Gerente de equipe
      if (task.status === 'aguardando' && actualTime <= stepTask.date_evaluation_step2_finish) {
        upsertStatus({ stage0: 'Aguardando validação' });
      } else if (task.status === 'aguardando' && actualTime > stepTask.date_evaluation_step2_finish) {
        upsertStatus({ stage0: 'Prazo expirado' });
      } else if (task.status === 'rejeitado') {
        upsertStatus({ stage0: 'Devolvida' });
      } else if (task.multiplicador && task.multiplicador >= 1) {
        upsertStatus({ stage0: 'Validada' });
      }

      // Nível 1
      if (taskStep > 2) {
        if (
          task.status === 'aprovado' &&
          task.multiplicador &&
          task.multiplicador === 1 &&
          actualTime <= stepTask.date_evaluation_step3_finish
        ) {
          upsertStatus({ stage1: 'Aguardando apreciação' });
        } else if (
          task.status === 'aprovado' &&
          task.multiplicador &&
          task.multiplicador === 1 &&
          actualTime > stepTask.date_evaluation_step3_finish
        ) {
          upsertStatus({ stage1: 'Prazo expirado' });
        } else if (task.status === 'concluido' && task.multiplicador && task.multiplicador === 1 && taskStep === 3) {
          upsertStatus({ stage1: 'Validada - Finalizada' });
        } else if (
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          actualTime <= stepTask.date_evaluation_step3_finish
        ) {
          upsertStatus({ stage1: 'Bonificada' });
        } else if (
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          actualTime > stepTask.date_evaluation_step3_finish
        ) {
          upsertStatus({ stage1: 'Bonificada - Prazo expirado' });
        } else if (
          (task.status === 'concluido' || task.status === 'concluidoAuto') &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          taskStep === 3
        ) {
          upsertStatus({ stage1: 'Bonificada - Finalizada' });
        } else if (task.multiplicador && task.multiplicador >= 2 && taskStep > 3) {
          upsertStatus({ stage1: 'Promovida' });
        }
      }

      // Nível 2
      if (taskStep > 3) {
        if (
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          (!stepTask.date_evaluation_step4_finish || actualTime <= stepTask.date_evaluation_step4_finish)
        ) {
          upsertStatus({ stage2: 'Aguardando apreciação' });
        } else if (
          stepTask.date_evaluation_step4_finish &&
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          actualTime > stepTask.date_evaluation_step4_finish
        ) {
          upsertStatus({ stage2: 'Prazo expirado' });
        } else if (task.status === 'concluido' && task.multiplicador && task.multiplicador === 2 && taskStep === 4) {
          upsertStatus({ stage2: 'Promovida ao nível 2 - Finalizada' });
        } else if (
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          (!stepTask.date_evaluation_step4_finish || actualTime <= stepTask.date_evaluation_step4_finish)
        ) {
          upsertStatus({ stage2: 'Bonificada' });
        } else if (
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          actualTime > stepTask.date_evaluation_step4_finish
        ) {
          upsertStatus({ stage2: 'Bonificada - Prazo expirado' });
        } else if (
          (task.status === 'concluido' || task.status === 'concluidoAuto') &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          taskStep === 4
        ) {
          upsertStatus({ stage2: 'Bonificada - Finalizada' });
        } else if (task.multiplicador && task.multiplicador >= 4 && taskStep > 4) {
          upsertStatus({ stage2: 'Promovida' });
        }
      }

      // Nível 3
      if (taskStep > 4) {
        if (
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          (!stepTask.date_evaluation_step5_finish || actualTime <= stepTask.date_evaluation_step5_finish)
        ) {
          upsertStatus({ stage3: 'Aguardando apreciação' });
        } else if (
          stepTask.date_evaluation_step5_finish &&
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          actualTime > stepTask.date_evaluation_step5_finish
        ) {
          upsertStatus({ stage3: 'Prazo expirado' });
        } else if (task.status === 'concluido' && task.multiplicador && task.multiplicador === 4) {
          upsertStatus({ stage3: 'Promovida ao nível 3 - Finalizada' });
        } else if (
          stepTask.date_evaluation_step5_finish &&
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 8 &&
          actualTime <= stepTask.date_evaluation_step5_finish
        ) {
          upsertStatus({ stage3: 'Bonificada' });
        } else if (
          stepTask.date_evaluation_step5_finish &&
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 8 &&
          actualTime > stepTask.date_evaluation_step5_finish
        ) {
          upsertStatus({ stage3: 'Bonificada - Prazo expirado' });
        } else if (
          (task.status === 'concluido' || task.status === 'concluidoAuto') &&
          task.multiplicador &&
          task.multiplicador === 8
        ) {
          upsertStatus({ stage3: 'Bonificada - Finalizada' });
        } else if (task.status === 'selo' || task.status === 'mandou' || task.status === 'valeu') {
          upsertStatus({
            stage3: `${task.status === 'selo' ? 'Bonificada UAU' : task.status === 'mandou' ? 'Bonificada Mandou Bem' : task.status === 'valeu' ? 'Bonificada Valeu' : 'Premiada'} - Finalizada`,
          });
        }
      }

      if (
        !!userCodEtapa(task.original_manager_detail, !!task.mad) &&
        userCodEtapa(task.original_manager_detail, !!task.mad) === 5
      ) {
        if (
          task.status === 'aguardando' &&
          (((task.original_manager_detail?.cod_funcao === 3001 || task.original_manager_detail?.cod_funcao === 3002) &&
            actualTime <= stepTask.date_evaluation_step5_finish) ||
            (task.original_manager_detail?.cod_funcao !== 3001 &&
              task.original_manager_detail?.cod_funcao !== 3002 &&
              actualTime < stepTask.date_evaluation_step5_start))
        ) {
          upsertStatus({ stage0: 'Aguardando validação' });
        }

        if (
          taskStep > 2 &&
          task.status === 'aprovado' &&
          task.multiplicador &&
          task.multiplicador === 1 &&
          (((task.original_manager_detail?.cod_funcao === 3001 || task.original_manager_detail?.cod_funcao === 3002) &&
            actualTime <= stepTask.date_evaluation_step5_finish) ||
            (task.original_manager_detail?.cod_funcao !== 3001 &&
              task.original_manager_detail?.cod_funcao !== 3002 &&
              actualTime < stepTask.date_evaluation_step5_start))
        ) {
          upsertStatus({ stage1: 'Aguardando apreciação' });
        }
      }

      if (
        !!userCodEtapa(task.original_manager_detail, !!task.mad) &&
        userCodEtapa(task.original_manager_detail, !!task.mad) === 4
      ) {
        if (
          task.status === 'aguardando' &&
          stepTask.date_evaluation_step4_start &&
          actualTime <= stepTask.date_evaluation_step4_start
        ) {
          upsertStatus({ stage0: 'Aguardando validação' });
        }

        if (
          taskStep > 2 &&
          task.status === 'aprovado' &&
          task.multiplicador &&
          task.multiplicador === 1 &&
          stepTask.date_evaluation_step4_start &&
          actualTime <= stepTask.date_evaluation_step4_start
        ) {
          upsertStatus({ stage1: 'Aguardando apreciação' });
        }
      }

      const values = statuses.map(item => Object.values(item)[0]);
      return values.filter((value, index, self) => self.indexOf(value) === index);
    },
    [realCycle, userCodEtapa],
  );

  const isOriginalManager = useMemo(() => {
    if (!filteredData?.length) return false;
    return !!filteredData.find(
      x =>
        x.original_manager &&
        (x.original_manager === playerInfo?._id ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(x.original_manager)))),
    );
  }, [filteredData, playerInfo]);

  const isOriginalManagerCod5 = useMemo(() => {
    if (!filteredData?.length || !playerInfo) return false;
    return !!filteredData.find(
      x =>
        x.original_manager &&
        (x.original_manager === playerInfo?._id ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(x.original_manager)))) &&
        userCodEtapa() &&
        userCodEtapa() === 5,
    );
  }, [filteredData, playerInfo, userCodEtapa]);

  const optionsPairs = useMemo(() => {
    if (!playerInfo?._id) return [];

    const def = [
      {
        label: playerInfo?.nome_guerra,
        value: playerInfo?._id,
      },
    ];

    return [
      ...def,
      ...(Array.isArray(playerInfo.mad_dupla)
        ? playerInfo.mad_dupla.map((x: any) => {
            return {
              label: `${x.nome_guerra} (${x.chave})`,
              value: x._id,
            };
          })
        : []),
    ];
  }, [playerInfo?._id, playerInfo?.mad_dupla, playerInfo?.nome_guerra]);

  const clarifyingText = useMemo(() => {
    if (
      !playerInfo ||
      !Array.isArray(filteredData) ||
      !userCodEtapa() ||
      typeof userCodEtapa() !== 'number' ||
      userCodEtapa() < 1 ||
      userCodEtapa() > 5
    )
      return <></>;

    const _tasks = [...(filteredData as any[])];
    let stepMsg;

    if (userCodEtapa() === 4 && !!isOriginalManager) {
      if (typeof getActiveEvaluationStep === 'number') {
        if (getActiveEvaluationStep === 2) {
          stepMsg = 0;
        } else if (getActiveEvaluationStep === 3) {
          stepMsg = 1;
        } else {
          stepMsg = 2;
        }
      } else {
        stepMsg = 2;
      }
    } else if (userCodEtapa() === 5 && !!isOriginalManager) {
      if (typeof getActiveEvaluationStep === 'number') {
        if (getActiveEvaluationStep === 2) {
          stepMsg = 0;
        } else if (getActiveEvaluationStep === 3) {
          stepMsg = 1;
        } else if (getActiveEvaluationStep === 4 || getActiveEvaluationStep === 4.1) {
          stepMsg = 2;
        } else {
          stepMsg = 3;
        }
      } else {
        stepMsg = 3;
      }
    } else {
      if (userCodEtapa() === 2) {
        stepMsg = 0;
      } else if (userCodEtapa() === 4) {
        stepMsg = 2;
      } else if (userCodEtapa() === 5) {
        stepMsg = 3;
      } else if (userCodEtapa() === 1 || userCodEtapa() === 3) {
        if (_tasks.length) {
          let hasLevel1 = false;

          _tasks.forEach(task => {
            if (
              typeof getTaskStep(task) === 'number' &&
              (getTaskStep(task) as number) >= 3 &&
              ((typeof getActiveEvaluationStep === 'number' && getActiveEvaluationStep > 2) || getActiveEvaluationStep === null)
            ) {
              hasLevel1 = true;
            }
          });

          stepMsg = hasLevel1 ? 1 : 0;
        } else {
          stepMsg = 0;
        }
      }
    }

    if (typeof stepMsg === 'number') {
      if (stepMsg === 1) {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">Apreciação das realizações validadas</p>
            <p className="text-white text-base font-thin mb-1">
              Cada realização recebida por você foi <strong className="font-bold">validada</strong> por funcionário pertencente à
              função gerencial e recebeu 300 (trezentos) pontos.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR todas as realizações que considerar mais relevantes em seu âmbito de
              atuação, e PROMOVER ao próximo nível, até 10% (dez por cento) das realizações bonificadas que você considerar
              extraordinárias.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A realização <strong className="font-bold">bonificada</strong> passará a 600 (seiscentos) pontos e a{' '}
              <strong className="font-bold">promovida</strong> terá 100 (cem) pontos adicionais.
            </p>

            <p className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">as entregas</strong> recebidas você promove o engajamento e o desenvolvimento de sua
              equipe.
            </p>
          </>
        );
      } else if (stepMsg === 2) {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">Apreciação das entregas promovidas pelo nível 1</p>
            <p className="text-white text-base font-thin mb-1">
              Cada realização recebida por você foi promovida por funcionário responsável pela apreciação nível l e recebeu 600
              (seiscentos) pontos.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR VALEU para 100% das realizações, BONIFICAR MANDOU BEM para até 50%
              (cinquenta por cento) das realizações e BONIFICAR UAU para até 25% (vinte e cinco por cento) das realizações que
              você considerar extraordinárias.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A realização <strong className="font-bold">Bonificada Valeu</strong> passará a 1.500 (mil e quinhentos) pontos, a
              realização <strong className="font-bold">Bonificada Mandou Bem</strong> passará a 2.500 (dois mil e quinhentos)
              pontos e a realização <strong className="font-bold">Bonificada UAU</strong> passará a 5.000 (cinco mil) pontos.
            </p>

            <p className="text-white text-base font-light">
              E que tal deixar um feedback para a equipe? Afinal, reconhecimento nunca é demais!
            </p>
          </>
        );
      } else if (stepMsg === 3) {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">Apreciação das entregas promovidas pelo nível 2</p>
            <p className="text-white text-base font-thin mb-1">
              Cada realização recebida por você foi promovida por funcionário responsável pela apreciação nível 2 e recebeu 1.300
              (mil e trezentos) pontos.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Nesta apreciação, você poderá BONIFICAR VALEU para 100% das realizações, BONIFICAR MANDOU BEM para até 50%
              (cinquenta por cento) das realizações e BONIFICAR UAU para até 25% (vinte e cinco por cento) das realizações que
              você considerar extraordinárias.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A realização <strong className="font-bold">Bonificada Valeu</strong> passará a 1.500 (mil e quinhentos) pontos, a
              realização <strong className="font-bold">Bonificada Mandou Bem</strong> passará a 2.500 (dois mil e quinhentos)
              pontos e a realização <strong className="font-bold">Bonificada UAU</strong> passará a 5.000 (cinco mil) pontos.
            </p>

            <p className="text-white text-base font-light">
              E que tal deixar um feedback para a equipe? Afinal, reconhecimento nunca é demais!
            </p>
          </>
        );
      } else {
        return (
          <>
            <p className="text-dandelion text-lg font-semibold block mb-4">VALIDAÇÃO das entregas cadastradas por sua equipe</p>
            <p className="text-white text-base font-thin mb-1">
              Cada realização recebida por você foi cadastrada por um de seus liderados.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Para VALIDAR a entrega, verifique se há alinhamento com os indicadores e desafios da equipe, se não há informações
              sigilosas, duplicidade e ou conteúdo inadequado, caso contrário você pode DEVOLVER a realização.
            </p>
            <p className="text-white text-base font-thin mb-1">
              Ao ser devolvida, a realização volta para o responsável pelo cadastramento e se for corrigida, dentro do período de
              validação, você poderá analisá-la novamente.
            </p>
            <p className="text-white text-base font-thin mb-1">
              A realização <strong className="font-bold">validada</strong> recebe 300 (trezentos) pontos.
            </p>

            <p className="text-white text-base font-light">
              <span className="text-electric-blue">Lembre-se</span> que ao deixar feedback para{' '}
              <strong className="font-bold">as entregas</strong> recebidas você promove o engajamento e o desenvolvimento de sua
              equipe.
            </p>
          </>
        );
      }
    } else {
      return <></>;
    }
  }, [filteredData, getActiveEvaluationStep, isOriginalManager, playerInfo, userCodEtapa]);

  // const canShowBonus = useMemo(() => {
  //   if (isVacationManager) return false;
  //   if (
  //     filteredData?.filter((x: any) => x?.prosseguir_idGestor && x?.prosseguir_idGestor === playerInfo._id)?.length ===
  //     filteredData?.length
  //   )
  //     return false;
  //   if (activeStageObj && activeStageObj?.date_start < 1706886000000) return false;
  //   if (playerInfo?.cod_etapa > 0 && playerInfo?.cod_etapa !== 2) return true;

  //   return false;
  // }, [isVacationManager, activeStageObj, playerInfo, filteredData]);

  const getFullCalendar = useMemo(() => {
    if (!cyclesExtended || !cycleSelected) return null;

    const cycleActive = cyclesExtended.find(x => x._id === cycleSelected?._id);

    if (cycleActive) {
      const calendar = getFutureCalendar(cycleActive?.steps, realDatetime);
      // console.table(calendar);
      return calendar;
    }

    return null;
  }, [cycleSelected, cyclesExtended, realDatetime]);

  const taskAppreciationExpired = useCallback(
    (task: any) => {
      const _taskStep = getTaskStep(task);
      const _playerStep = getPlayerStep(task);

      // Realização MAD com prazo expirado na bonificação do nível 2. Voltar se for necessário
      // if (
      //   !!task.mad &&
      //   _taskStep === 4 &&
      //   task.status === 'promovido' &&
      //   task.multiplicador &&
      //   task.multiplicador === 2 &&
      //   activeStageObj &&
      //   realDatetime > activeStageObj.date_evaluation_step2_finish
      // ) {
      //   return true;
      // }

      if (activeStageObj && _taskStep && _playerStep && userCodEtapa(null, !!task.mad) && playerInfo) {
        // Gerente de equipe
        if (
          task.status === 'aguardando' &&
          realDatetime > activeStageObj.date_evaluation_step2_finish &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            (userCodEtapa(null, !!task.mad) === 4 || userCodEtapa(null, !!task.mad) === 5)
          )
        ) {
          return true;
        }

        // Nível 1
        if (
          task.status === 'aprovado' &&
          task.multiplicador &&
          task.multiplicador === 1 &&
          realDatetime > activeStageObj.date_evaluation_step3_finish &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            (userCodEtapa(null, !!task.mad) === 4 || userCodEtapa(null, !!task.mad) === 5)
          )
        ) {
          return true;
        }

        // Nível 1
        if (
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          realDatetime > activeStageObj.date_evaluation_step3_finish &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            (userCodEtapa(null, !!task.mad) === 4 || userCodEtapa(null, !!task.mad) === 5)
          )
        ) {
          return true;
        }

        // Nível 2
        if (
          activeStageObj.date_evaluation_step4_finish &&
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          realDatetime > activeStageObj.date_evaluation_step4_finish &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            userCodEtapa(null, !!task.mad) === 5
          )
        ) {
          return true;
        }

        // Nível 2
        if (
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          realDatetime > activeStageObj.date_evaluation_step4_finish &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            userCodEtapa(null, !!task.mad) === 5
          )
        ) {
          return true;
        }

        // Nível 3
        if (
          activeStageObj.date_evaluation_step5_finish &&
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          realDatetime > activeStageObj.date_evaluation_step5_finish
        ) {
          return true;
        }

        // Nível 3
        if (
          activeStageObj.date_evaluation_step5_finish &&
          task.status === 'dobrado' &&
          task.multiplicador &&
          task.multiplicador === 8 &&
          realDatetime > activeStageObj.date_evaluation_step5_finish
        ) {
          return true;
        }

        // if (
        //   (_playerStep === 2 && task.status === 'aguardando' && realDatetime > activeStageObj.date_evaluation_step2_finish) ||
        //   (_playerStep === 3 &&
        //     _taskStep <= 3 &&
        //     !(String(task.original_manager) === String(playerInfo?._id) && userCodEtapa() === 5) &&
        //     realDatetime > activeStageObj.date_evaluation_step2_finish) ||
        //   (_playerStep === 4 &&
        //     _taskStep === 3 &&
        //     task.status === 'aprovado' &&
        //     task.multiplicador &&
        //     task.multiplicador === 1 &&
        //     realDatetime > activeStageObj.date_evaluation_step2_finish) ||
        //   (_playerStep === 5 &&
        //     _taskStep === 4 &&
        //     task.status === 'promovido' &&
        //     task.multiplicador &&
        //     task.multiplicador === 2 &&
        //     realDatetime > activeStageObj.date_evaluation_step4_finish)
        // ) {
        //   return true;
        // }
      }

      return false;
    },
    [activeStageObj, getPlayerStep, playerInfo, realDatetime, userCodEtapa],
  );

  // TO DO: Mudar nomenclatura. Esse método não é utilizado apenas para reset.
  const canReset = useCallback(
    (task: any) => {
      if (
        !activeStageObj ||
        !getTaskStep(task) ||
        !playerInfo ||
        typeof userCodEtapa(null, !!task.mad) !== 'number' ||
        !task.original_manager ||
        realDatetime < activeStageObj.date_evaluation_step2_start ||
        realDatetime > activeStageObj.date_evaluation_step5_finish
      ) {
        return false;
      }

      // Gestor imediato apreciando realização expirada
      if (
        taskAppreciationExpired(task) &&
        isVacationManager &&
        (userInfo?._id === playerInfo?.gestor ||
          (Array.isArray(userInfo?.mad_dupla) &&
            userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor)))
      ) {
        if (
          !getActiveEvaluationStep &&
          ((userCodEtapa(userInfo, !!task.mad) === 4 && realDatetime < activeStageObj.date_evaluation_step4_start) ||
            (userCodEtapa(userInfo, !!task.mad) === 5 && realDatetime < activeStageObj.date_evaluation_step5_start))
        ) {
          return true;
        } else if (
          getActiveEvaluationStep &&
          ((getActiveEvaluationStep === 3 &&
            (userCodEtapa(userInfo, !!task.mad) === 1 || userCodEtapa(userInfo, !!task.mad) === 3)) ||
            (getActiveEvaluationStep === 3 &&
              userCodEtapa(userInfo, !!task.mad) === 4 &&
              (userCodEtapa(playerInfo, !!task.mad) === 1 || userCodEtapa(playerInfo, !!task.mad) === 3)) ||
            (getActiveEvaluationStep > 3 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!task.mad) === 4) ||
            (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!task.mad) === 5))
        ) {
          return true;
        }

        return false;
      }

      if (
        String(task.original_manager) === String(playerInfo._id) &&
        userCodEtapa(null, !!task.mad) === 5 &&
        (((task.original_manager_detail?.cod_funcao === 3001 || task.original_manager_detail?.cod_funcao === 3002) &&
          realDatetime <= activeStageObj.date_evaluation_step5_finish) ||
          (task.original_manager_detail?.cod_funcao !== 3001 &&
            task.original_manager_detail?.cod_funcao !== 3002 &&
            realDatetime < activeStageObj.date_evaluation_step5_start))
      ) {
        return true;
      }

      if (
        String(task.original_manager) === String(playerInfo._id) &&
        userCodEtapa(null, !!task.mad) === 4 &&
        realDatetime <= activeStageObj.date_evaluation_step4_finish
      ) {
        return true;
      }

      if (!getActiveEvaluationStep || !activeStageObj.type) {
        return false;
      }

      if (
        (getActiveEvaluationStep < 4 && activeStageObj.type !== 'month') ||
        (getActiveEvaluationStep >= 4 && getActiveEvaluationStep < 5 && activeStageObj.type !== 'trimester') ||
        (getActiveEvaluationStep >= 5 && activeStageObj.type !== 'semester')
      ) {
        return false;
      }

      if (
        Array.isArray(task.non_evaluator) &&
        task.non_evaluator.length &&
        task.non_evaluator.find((x: any) => x === playerInfo?._id)
      ) {
        const stepTask = cyclesExtended
          ?.find((x: { date_start: number; date_end: number }) => task.created > x.date_start && task.created <= x.date_end)
          ?.steps.find((x: any) => x.type && x.type === 'month' && task.created > x.date_start && task.created <= x.date_finish);
        const actualTime = +new Date();

        if (task.status === 'aguardando') {
          return true;
        }

        if (
          task.status === 'aprovado' &&
          task.multiplicador &&
          task.multiplicador === 1 &&
          stepTask &&
          actualTime >= stepTask.date_evaluation_step3_start &&
          actualTime <= stepTask.date_evaluation_step3_finish
        ) {
          return true;
        }

        if (
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 2 &&
          stepTask &&
          (!stepTask.date_evaluation_step4_finish ||
            (actualTime >= stepTask.date_evaluation_step4_start && actualTime <= stepTask.date_evaluation_step4_finish))
        ) {
          return true;
        }

        if (
          task.status === 'promovido' &&
          task.multiplicador &&
          task.multiplicador === 4 &&
          stepTask &&
          (!stepTask.date_evaluation_step5_finish ||
            (actualTime >= stepTask.date_evaluation_step5_start && actualTime <= stepTask.date_evaluation_step5_finish))
        ) {
          return true;
        }

        return false;
      }

      if (
        getActiveEvaluationStep === 2 &&
        activeStageObj.type &&
        (activeStageObj.type === 'semester' || activeStageObj.type === 'trimester') &&
        !(
          (String(task.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
          userCodEtapa(null, !!task.mad) === 5
        )
      ) {
        return false;
      }

      if (
        getActiveEvaluationStep === 4 &&
        (((getTaskStep(task) as number) < 4 &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            userCodEtapa(null, !!task.mad) === 5
          )) ||
        (activeStageObj.type &&
          activeStageObj.type !== 'trimester' &&
          !(
            (String(task.original_manager) === String(playerInfo._id) ||
              (Array.isArray(playerInfo?.mad_dupla) &&
                playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
            userCodEtapa(null, !!task.mad) === 5
          )))
      ) {
        return false;
      }

      if (getActiveEvaluationStep === 5 && activeStageObj.type && activeStageObj.type !== 'semester') {
        return false;
      }

      if (
        (String(task.original_manager) === String(playerInfo._id) ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
        (getActiveEvaluationStep === 2 || getActiveEvaluationStep === 3 || getActiveEvaluationStep === 4) &&
        userCodEtapa(null, !!task.mad) === 4
      ) {
        return true;
      }

      if (task.status === 'apreciacaoExpirada') {
        return false;
      }

      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) {
        if (getActiveEvaluationStep === 4.1) {
          return true;
        } else {
          return false;
        }
      }

      if (userCodEtapa(null, !!task.mad) === 2 && getActiveEvaluationStep === 2 && (getTaskStep(task) as number) >= 2) {
        // Versão 2S2024
        // if ((getTaskStep(task) as number) > 2 && (task.multiplicador > 1 || task.status.match(/(concluido|concluidoAuto)/g))) {
        //   return false;
        // }

        return true;
      }

      // Versão 2S2024
      // if (userCodEtapa() === 4 && getActiveEvaluationStep === 2 && (getTaskStep(task) as number) === 4 && playerInfo.mad) {
      //   return true;
      // }

      if (userCodEtapa(null, !!task.mad) === 4 && getActiveEvaluationStep === 4 && (getTaskStep(task) as number) >= 4) {
        // Versão 2S2024
        // if (
        //   (getTaskStep(task) as number) > 4 &&
        //   (task.multiplicador > 4 ||
        //     task.status.match(/(concluido|concluidoAuto)/g) ||
        //     (typeof task.prosseguir_gst === 'string' &&
        //       (task.prosseguir_gst === 'stopped' || task.prosseguir_gst === 'approved')))
        // ) {
        //   return false;
        // }

        return true;
      }

      if (userCodEtapa(null, !!task.mad) === 5 && getActiveEvaluationStep === 5 && (getTaskStep(task) as number) >= 5) {
        return true;
      }

      if (
        (String(task.original_manager) === String(playerInfo._id) ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
        (getActiveEvaluationStep === 2 || getActiveEvaluationStep === 3) &&
        (userCodEtapa(null, !!task.mad) === 1 || userCodEtapa(null, !!task.mad) === 3)
      ) {
        return (getTaskStep(task) as number) >= getActiveEvaluationStep;
      }

      if (
        (userCodEtapa(null, !!task.mad) === 1 || userCodEtapa(null, !!task.mad) === 3) &&
        String(task.original_manager) !== String(playerInfo._id) &&
        getActiveEvaluationStep === 3 &&
        (getTaskStep(task) as number) >= 3
      ) {
        return true;
      }

      if (
        (String(task.original_manager) === String(playerInfo._id) ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
        (getActiveEvaluationStep === 2 || getActiveEvaluationStep === 3) &&
        userCodEtapa(null, !!task.mad) === 4
      ) {
        return (getTaskStep(task) as number) >= getActiveEvaluationStep;
      }

      if (
        (String(task.original_manager) === String(playerInfo._id) ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
        userCodEtapa(null, !!task.mad) === 5 &&
        !!getActiveEvaluationStep
      ) {
        // Presidente e vice-presidente
        if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
          return true;
        } else {
          // Diretores e gerentes gerais
          if (getActiveEvaluationStep < 5) {
            return true;
          } else {
            return getTaskStep(task) === getActiveEvaluationStep;
          }
        }
      }

      return false;
    },
    [
      activeStageObj,
      getActiveEvaluationStep,
      isVacationManager,
      playerInfo,
      cyclesExtended,
      realDatetime,
      taskAppreciationExpired,
      userCodEtapa,
      userInfo,
    ],
  );

  function canDouble(task: any) {
    if (
      !canReset(task) ||
      !getTaskStep(task) ||
      !activeStageObj ||
      (getTaskStep(task) as number) >= 5 ||
      (getTaskStep(task) as number) === 4.1 ||
      getPlayerStep(task) === 4.1 ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number' ||
      typeof userCodEtapa(null, !!task.mad) !== 'number' ||
      getTaskStep(task) === 2 ||
      getPlayerStep(task) === 2 ||
      (getTaskStep(task) as number) > getPlayerStep(task) ||
      (doubledTasks.length >= maxDoubledTasks &&
        !(
          (String(task.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
          userCodEtapa(null, !!task.mad) === 5
        ))
      /*(((getTaskStep(task) === 3 && getActiveEvaluationStep !== 2) ||
        (playerInfo.mad &&
          ((getTaskStep(task) === 4 && getPlayerStep(task) !== 4) ||
            (getTaskStep(task) === 4 && getPlayerStep(task) === 4 && getActiveEvaluationStep !== 2))) ||
        (!playerInfo.mad && getTaskStep(task) === 4 && getActiveEvaluationStep !== 4)) &&
        !(String(task.original_manager) === String(playerInfo._id) && userCodEtapa() === 5))*/
    ) {
      return false;
    }

    // Gestor imediato apreciando realização expirada
    if (
      taskAppreciationExpired(task) &&
      isVacationManager &&
      (userInfo?._id === playerInfo?.gestor ||
        (Array.isArray(userInfo?.mad_dupla) &&
          userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor))) &&
      ((getTaskStep(task) === 3 && task.multiplicador === 1) || (getTaskStep(task) === 4 && task.multiplicador === 2))
    ) {
      if (
        !getActiveEvaluationStep &&
        ((userCodEtapa(userInfo, !!task.mad) === 4 && realDatetime < activeStageObj.date_evaluation_step4_start) ||
          (userCodEtapa(userInfo, !!task.mad) === 5 && realDatetime < activeStageObj.date_evaluation_step5_start))
      ) {
        return true;
      } else if (
        getActiveEvaluationStep &&
        ((getActiveEvaluationStep > 3 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!task.mad) === 4) ||
          (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!task.mad) === 5))
      ) {
        return true;
      }

      return false;
    }

    if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 5
    ) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return task.status === 'aprovado';
      } else {
        // Diretores e gerentes gerais
        if (realDatetime < activeStageObj.date_evaluation_step5_start) {
          return task.status === 'aprovado';
        } else {
          return (
            realDatetime <= activeStageObj.date_evaluation_step5_finish &&
            task.status === 'promovido' &&
            task.multiplicador &&
            task.multiplicador === 4
          );
        }
      }
    }

    if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 4 &&
      activeStageObj.date_evaluation_step4_start &&
      realDatetime < activeStageObj.date_evaluation_step4_start
    ) {
      if (getTaskStep(task) === 3 && task.multiplicador === 1) {
        return true;
      }
    }

    if (!getActiveEvaluationStep) {
      return false;
    }

    if (getTaskStep(task) === 3 && task.multiplicador === 1 && getActiveEvaluationStep === 3) {
      return true;
    }

    if (
      getTaskStep(task) === 4 &&
      task.multiplicador === 2 &&
      getActiveEvaluationStep === 4
      // (getActiveEvaluationStep === 2 || getActiveEvaluationStep === 4)
      // ((playerInfo.mad && getActiveEvaluationStep === 2) || (!playerInfo.mad && getActiveEvaluationStep === 4))
    ) {
      return true;
    }

    // if (getTaskStep(task) === 5 && task.multiplicador === 4) {
    //   return true;
    // }

    return false;
  }

  function canPromote(task: any, originalTask: any) {
    if (
      !canReset(originalTask) ||
      !getTaskStep(task) ||
      !activeStageObj ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number' ||
      typeof userCodEtapa(null, !!task.mad) !== 'number' ||
      getTaskStep(task) === 2 ||
      (promotedTasks.length >= maxPromotedTasks &&
        !(
          (String(task.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
          userCodEtapa(null, !!task.mad) === 5
        ))
      // (getTaskStep(task) !== getActiveEvaluationStep &&
      //   !(String(task.original_manager) === String(playerInfo._id) && userCodEtapa() === 5)) ||
      // (getActiveEvaluationStep < 3 &&
      //   !(String(task.original_manager) === String(playerInfo._id) && userCodEtapa() === 5)) ||
    ) {
      return false;
    }

    // Gestor imediato apreciando realização expirada
    if (
      isVacationManager &&
      (userInfo?._id === playerInfo?.gestor ||
        (Array.isArray(userInfo?.mad_dupla) &&
          userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor))) &&
      ((task.status === 'dobrado' && getTaskStep(task) === 3 && task.multiplicador === 2) ||
        (task.status === 'dobrado' && getTaskStep(task) === 4 && task.multiplicador === 4))
    ) {
      if (
        !getActiveEvaluationStep &&
        ((userCodEtapa(userInfo, !!task.mad) === 4 && realDatetime < activeStageObj.date_evaluation_step4_start) ||
          (userCodEtapa(userInfo, !!task.mad) === 5 && realDatetime < activeStageObj.date_evaluation_step5_start))
      ) {
        return true;
      } else if (
        getActiveEvaluationStep &&
        ((getActiveEvaluationStep > 3 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!task.mad) === 4) ||
          (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!task.mad) === 5))
      ) {
        return true;
      }

      return false;
    }

    if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 4 &&
      activeStageObj.date_evaluation_step4_start &&
      realDatetime < activeStageObj.date_evaluation_step4_start
    ) {
      if (task.status === 'dobrado' && getTaskStep(task) === 3 && task.multiplicador === 2) {
        return true;
      }
    }

    if (!getActiveEvaluationStep) {
      return false;
    }

    if (isVacationManager && promotedTasks.length >= maxPromotedTasks) return false;

    if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 5
    ) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return false;
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep < 5) {
          return false;
        } else {
          return (
            getTaskStep(task) === getActiveEvaluationStep &&
            task.status === 'dobrado' &&
            task.multiplicador &&
            task.multiplicador === 8
          );
        }
      }
    }

    if (
      task.status === 'promovido' &&
      getTaskStep(task) === 4.1 &&
      getPlayerStep(task) === 4.1 &&
      getActiveEvaluationStep === 4 &&
      task.prosseguir_gst === 'next'
    ) {
      return true;
    }

    // if(getTaskStep(task) === 5 && task.multiplicador === 8 && promotedTasks.length >= maxPromotedTasks) {
    //   return false;
    // }

    if (task.status === 'dobrado') {
      if (getTaskStep(task) === 3 && task.multiplicador === 2 && getActiveEvaluationStep === 3) {
        return true;
      }

      if (getTaskStep(task) === 4 && task.multiplicador === 4 && getActiveEvaluationStep === 4) {
        return true;
      }

      if (getTaskStep(task) === 5 && task.multiplicador === 8 && getActiveEvaluationStep === 5) {
        return true;
      }
    }

    // if (bonus?.hasBonus && !bonus?.isUsed && task.status === 'concluidoAuto' && !isVacationManager) return true;

    return false;
  }

  const canAward = useCallback(
    (task: any, modal = false) => {
      const obj = {
        uau: false,
        mandou: false,
        valeu: false,
      };

      if (
        !task ||
        !canReset(task) ||
        typeof task.multiplicador !== 'number' ||
        typeof task.stageNumber !== 'number' ||
        typeof task.status !== 'string' ||
        typeof task.original_manager !== 'string' ||
        typeof userCodEtapa(null, !!task.mad) !== 'number' ||
        !task.original_manager.length ||
        !playerInfo?._id
      ) {
        return obj;
      }

      const isOriginalManager =
        String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)));

      if (isOriginalManager && userCodEtapa(null, !!task.mad) && userCodEtapa(null, !!task.mad) === 5 && !!modal) {
        return {
          uau: Array.isArray(uauTasks) && uauTasks.length < maxUauTasks,
          mandou: Array.isArray(mandouBemTasks) && mandouBemTasks.length < maxMandouBemTasks,
          valeu: true,
        };
      }

      if (
        userCodEtapa(null, !!task.mad) !== 5 ||
        (getActiveEvaluationStep && getActiveEvaluationStep !== 5) ||
        task.status !== 'promovido'
      ) {
        return obj;
      }

      const taskPoints = calcPoints(task.multiplicador, task.status, task.stageNumber);

      if (taskPoints >= 1500) {
        return obj;
      }

      obj.uau = Array.isArray(uauTasks) && uauTasks.length < maxUauTasks;
      obj.mandou = Array.isArray(mandouBemTasks) && mandouBemTasks.length < maxMandouBemTasks;
      obj.valeu = true;

      return obj;
    },
    [
      canReset,
      getActiveEvaluationStep,
      mandouBemTasks,
      maxMandouBemTasks,
      maxUauTasks,
      playerInfo?._id,
      playerInfo?.mad_dupla,
      uauTasks,
      userCodEtapa,
    ],
  );

  function canPromoteWithNoBonus(task: any) {
    if (
      !canReset(task) ||
      !getTaskStep(task) ||
      !getActiveEvaluationStep ||
      typeof task.multiplicador !== 'number' ||
      typeof task.stageNumber !== 'number' ||
      typeof userCodEtapa(null, !!task.mad) !== 'number' ||
      (getTaskStep(task) !== getActiveEvaluationStep &&
        !(String(task.original_manager) === String(playerInfo._id) && userCodEtapa(null, !!task.mad) === 5)) ||
      (getActiveEvaluationStep < 3 &&
        !(String(task.original_manager) === String(playerInfo._id) && userCodEtapa(null, !!task.mad) === 5)) ||
      promotedTasks.length >= maxPromotedTasks
    ) {
      return false;
    }

    if (isVacationManager && promotedTasks.length >= maxPromotedTasks) return false;

    if (String(task.original_manager) === String(playerInfo._id) && userCodEtapa(null, !!task.mad) === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return false;
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep < 5) {
          return false;
        } else {
          return (
            getTaskStep(task) === getActiveEvaluationStep &&
            task.status === 'dobrado' &&
            task.multiplicador &&
            task.multiplicador === 8
          );
        }
      }
    }

    if (
      task.status === 'promovido' &&
      getTaskStep(task) === 4.1 &&
      getPlayerStep(task) === 4.1 &&
      getActiveEvaluationStep === 4.1 &&
      task.prosseguir_gst === 'next'
    ) {
      return true;
    }

    // if(getTaskStep(task) === 5 && task.multiplicador === 8 && promotedTasks.length >= maxPromotedTasks) {
    //   return false;
    // }

    if (task.status === 'dobrado') {
      if (getTaskStep(task) === 3 && task.multiplicador === 2) {
        return true;
      }

      if (getTaskStep(task) === 4 && task.multiplicador === 4) {
        return true;
      }

      if (getTaskStep(task) === 5 && task.multiplicador === 8) {
        return true;
      }
    }

    return false;
  }

  function canEdit(task: any) {
    if (
      !activeStageObj ||
      !canReset(task) ||
      typeof userCodEtapa(null, !!task.mad) !== 'number' ||
      userCodEtapa(null, !!task.mad) < 1 ||
      userCodEtapa(null, !!task.mad) > 5 ||
      task.status === 'concluido' ||
      task.status === 'concluidoAuto' ||
      task.status === 'apreciacaoExpirada'
    ) {
      return false;
    }

    // Gestor imediato apreciando realização expirada
    if (
      taskAppreciationExpired(task) &&
      isVacationManager &&
      (userInfo?._id === playerInfo?.gestor ||
        (Array.isArray(userInfo?.mad_dupla) &&
          userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor)))
    ) {
      if (
        !getActiveEvaluationStep &&
        ((userCodEtapa(userInfo, !!task.mad) === 4 && realDatetime < activeStageObj.date_evaluation_step4_start) ||
          (userCodEtapa(userInfo, !!task.mad) === 5 && realDatetime < activeStageObj.date_evaluation_step5_start))
      ) {
        return true;
      } else if (
        getActiveEvaluationStep &&
        ((getActiveEvaluationStep === 3 &&
          (userCodEtapa(userInfo, !!task.mad) === 1 || userCodEtapa(userInfo, !!task.mad) === 3)) ||
          (getActiveEvaluationStep === 3 &&
            userCodEtapa(userInfo, !!task.mad) === 4 &&
            (userCodEtapa(playerInfo, !!task.mad) === 1 || userCodEtapa(playerInfo, !!task.mad) === 3)) ||
          (getActiveEvaluationStep > 3 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!task.mad) === 4) ||
          (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!task.mad) === 5))
      ) {
        return true;
      }

      return false;
    }

    if (
      String(task.original_manager) === String(playerInfo._id) &&
      userCodEtapa(null, !!task.mad) === 5 &&
      (((task.original_manager_detail?.cod_funcao === 3001 || task.original_manager_detail?.cod_funcao === 3002) &&
        realDatetime <= activeStageObj.date_evaluation_step5_finish) ||
        (task.original_manager_detail?.cod_funcao !== 3001 &&
          task.original_manager_detail?.cod_funcao !== 3002 &&
          realDatetime < activeStageObj.date_evaluation_step5_start))
    ) {
      return true;
    }

    if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 4 &&
      activeStageObj.date_evaluation_step4_start &&
      realDatetime < activeStageObj.date_evaluation_step4_start
    ) {
      return true;
    }

    if (!getActiveEvaluationStep) {
      return false;
    }

    if (task.status === 'aguardando') {
      return true;
    }

    if (task.multiplicador === 1 && getActiveEvaluationStep === 3 && getTaskStep(task) === 3) {
      return true;
    }

    if (task.status === 'promovido' && task.multiplicador === 2 && getActiveEvaluationStep === 4) {
      return true;
    }

    if (task.status === 'promovido' && task.multiplicador === 4 && getActiveEvaluationStep === 5) {
      return true;
    }

    return false;
  }

  function canEvaluate(item: any) {
    try {
      const dateStart = activeStageObj?.date_evaluation_step2_start;
      const dateFinish = activeStageObj?.date_evaluation_step5_finish
        ? activeStageObj.date_evaluation_step5_finish
        : activeStageObj?.date_evaluation_step4_finish
          ? activeStageObj.date_evaluation_step4_finish
          : activeStageObj?.date_evaluation_step3_finish
            ? activeStageObj?.date_evaluation_step3_finish
            : activeStageObj?.date_evaluation_step2_finish
              ? activeStageObj?.date_evaluation_step2_finish
              : null;

      // Gestor imediato apreciando realização expirada
      if (
        taskAppreciationExpired(item) &&
        isVacationManager &&
        (userInfo?._id === playerInfo?.gestor ||
          (Array.isArray(userInfo?.mad_dupla) &&
            userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor))) &&
        activeStageObj
      ) {
        if (
          !getActiveEvaluationStep &&
          ((userCodEtapa(userInfo, !!item.mad) === 4 && realDatetime < activeStageObj.date_evaluation_step4_start) ||
            (userCodEtapa(userInfo, !!item.mad) === 5 && realDatetime < activeStageObj.date_evaluation_step5_start))
        ) {
          return true;
        } else if (
          getActiveEvaluationStep &&
          ((getActiveEvaluationStep === 3 &&
            (userCodEtapa(userInfo, !!item.mad) === 1 || userCodEtapa(userInfo, !!item.mad) === 3)) ||
            (getActiveEvaluationStep === 3 &&
              userCodEtapa(userInfo, !!item.mad) === 4 &&
              (userCodEtapa(playerInfo, !!item.mad) === 1 || userCodEtapa(playerInfo, !!item.mad) === 3)) ||
            (getActiveEvaluationStep > 3 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!item.mad) === 4) ||
            (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!item.mad) === 5))
        ) {
          return true;
        }

        return false;
      }

      if (
        String(item.original_manager) === String(playerInfo._id) &&
        userCodEtapa(null, !!item.mad) === 5 &&
        activeStageObj &&
        (((item.original_manager_detail?.cod_funcao === 3001 || item.original_manager_detail?.cod_funcao === 3002) &&
          realDatetime <= activeStageObj.date_evaluation_step5_finish) ||
          (item.original_manager_detail?.cod_funcao !== 3001 &&
            item.original_manager_detail?.cod_funcao !== 3002 &&
            realDatetime < activeStageObj.date_evaluation_step5_start))
      ) {
        return true;
      }

      if (
        (String(item.original_manager) === String(playerInfo._id) ||
          (Array.isArray(playerInfo?.mad_dupla) &&
            playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(item.original_manager)))) &&
        userCodEtapa(null, !!item.mad) === 4 &&
        activeStageObj &&
        activeStageObj.date_evaluation_step4_start &&
        realDatetime < activeStageObj.date_evaluation_step4_start
      ) {
        return true;
      }

      if (!getActiveEvaluationStep || !activeStageObj) {
        return false;
      }

      if (
        !!activeStageObj &&
        typeof userCodEtapa(null, !!item.mad) === 'number' &&
        !!getActiveEvaluationStep &&
        dateStart &&
        dateFinish &&
        realDatetime >= dateStart &&
        realDatetime <= dateFinish
      ) {
        if (
          (String(item.original_manager) === String(playerInfo._id) ||
            (Array.isArray(playerInfo?.mad_dupla) &&
              playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(item.original_manager)))) &&
          userCodEtapa(null, !!item.mad) === 5
        ) {
          // Presidente e vice-presidente
          if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
            return true;
          } else {
            // Diretores e gerentes gerais
            if (getActiveEvaluationStep < 5) {
              return true;
            } else {
              if (getTaskStep(item) === 2 && getActiveEvaluationStep === 2) return true;
              else if (getTaskStep(item) === 3 && getActiveEvaluationStep === 3) return true;
              else if (getTaskStep(item) === 4 && getActiveEvaluationStep === 4) return true;
              else if (getTaskStep(item) === 4.1 && getActiveEvaluationStep === 4.1) return true;
              else if (getTaskStep(item) === 5 && getActiveEvaluationStep === 5) return true;
              else return false;
            }
          }
        } else {
          if (getTaskStep(item) === 2 && getActiveEvaluationStep === 2) return true;
          else if (getTaskStep(item) === 3 && getActiveEvaluationStep === 3) return true;
          // else if (getTaskStep(item) === 4 && getActiveEvaluationStep === 2 && playerInfo.mad) return true;
          else if (getTaskStep(item) === 4 && getActiveEvaluationStep === 4) return true;
          else if (getTaskStep(item) === 4.1 && getActiveEvaluationStep === 4.1) return true;
          else if (getTaskStep(item) === 5 && getActiveEvaluationStep === 5) return true;
          else return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  const getUserInfo = useCallback(async () => {
    try {
      if (playerInfo && playerInfo.chave === internalUser?._id) return;

      const playerInfoResult = await getPlayerInfo(internalUser?._id, null, true);

      if (playerInfoResult) {
        setIsGestor(playerInfoResult.is_manager);
        setPlayerInfo(playerInfoResult);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  }, [internalUser?._id, playerInfo]);

  const getBonus = useCallback(async () => {
    try {
      const data = await verifyBonus(activeCycleSelected);
      setBonus(data);

      setLoadBonus(false);
    } catch (e) {
      console.log(e);
    }
  }, [activeCycleSelected]);

  const loadData = useCallback(
    async (taskId?: string) => {
      if (!!activeStageObj) {
        setTasksStatus([]);
        setSelectedTasksStatus(undefined);
        setSearchText(undefined);

        // setData(undefined);
        const myTasks = await getTasksManager(
          internalUser?.extra.id,
          activeStageObj.date_start,
          activeStageObj.date_finish,
          activeStageObj.step,
          taskId,
        );

        if (Array.isArray(myTasks) && myTasks?.length > 0) {
          const tasks: any = [];

          myTasks.forEach(task => {
            tasks.push({
              ...task,
              statuses: getTaskStatuses(task) || [],
            });
          });

          if (typeof taskId === 'string' && taskId.length) {
            const taskObj = tasks.find((t: { _id: string }) => t._id === taskId);

            setData(prevdata => {
              return Array.isArray(prevdata) && prevdata.length
                ? prevdata.map(d => {
                    return d._id === taskId ? taskObj : d;
                  })
                : tasks;
            });
          } else {
            setData(tasks);
          }

          return typeof taskId === 'string' && taskId.length ? tasks.find((b: { _id: string }) => b._id === taskId) : tasks;
        } else {
          setData([]);
          setFilteredData([]);
          setLoading(false);
          return typeof taskId === 'string' && taskId.length ? null : [];
        }

        // getBonus();
      }
    },
    [activeStageObj, getTaskStatuses, internalUser?.extra?.id],
  );

  async function updateAllTasks(action: string, nObj: any, oldObj?: any) {
    let taskId;

    try {
      setPageLoading(true);

      const newObj = JSON.parse(JSON.stringify(nObj));

      const isDuo = {
        original_manager:
          Array.isArray(newObj.non_evaluator_detail) &&
          Array.isArray(newObj.non_evaluator_detail.find((x: any) => x._id === playerInfo._id)?.mad_dupla) &&
          !!newObj.non_evaluator_detail
            .find((x: any) => x._id === playerInfo._id)
            ?.mad_dupla.find((md: any) => md._id && md._id === String(newObj.original_manager)),
        evaluator:
          Array.isArray(newObj.non_evaluator_detail) &&
          Array.isArray(newObj.non_evaluator_detail.find((x: any) => x._id === playerInfo._id)?.mad_dupla) &&
          Array.isArray(newObj.evaluator) &&
          !!newObj.evaluator.find(
            (ev: any) =>
              !!newObj.non_evaluator_detail
                .find((x: any) => x._id === playerInfo._id)
                ?.mad_dupla?.find((md: any) => md._id === ev),
          ),
      };

      if (isDuo.original_manager) {
        const index_non_evaluator = newObj.non_evaluator.indexOf(playerInfo._id);
        if (index_non_evaluator !== -1) {
          newObj.non_evaluator[index_non_evaluator] = '' + newObj.original_manager;
          newObj.original_manager = playerInfo._id;
        }
      } else if (isDuo.evaluator) {
        const detail = newObj.non_evaluator_detail.find((x: any) => x._id === playerInfo._id);

        const matchingMadId = Array.isArray(detail?.mad_dupla)
          ? detail.mad_dupla.map((md: any) => md._id).find((id: string) => newObj.evaluator.includes(id))
          : null;

        const index_non_evaluator = newObj.non_evaluator.indexOf(playerInfo._id);
        const index_evaluator = matchingMadId ? newObj.evaluator.indexOf(matchingMadId) : -1;

        if (index_non_evaluator !== -1 && index_evaluator !== -1 && matchingMadId) {
          newObj.non_evaluator[index_non_evaluator] = matchingMadId;
          newObj.evaluator[index_evaluator] = playerInfo._id;
        }
      }

      if (!!action.match(/(accept|stop|reject|double|award)/g)) {
        taskId = newObj._id;
        await updateTask(newObj);
        return true;
      } else if (!!action.match(/(promote|reset)/g)) {
        if (action === 'promote') {
          if (newObj.prosseguir_idGestor === playerInfo._id) {
            taskId = newObj._id;
            await updateTask(newObj);
            return true;
          } else {
            const _promotedTasks = promotedTasks.filter((x: any) => x._id !== newObj._id);
            _promotedTasks.push(newObj);

            const tasks = [...(filteredData as any[])].filter((x: any) => {
              if (
                x._id !== newObj._id &&
                canReset(x) &&
                x.status === 'dobrado' &&
                x.multiplicador === newObj.multiplicador &&
                _promotedTasks.length >= maxPromotedTasks
              ) {
                return true;
              }

              return false;
            });

            if (tasks.length) {
              await actionLog('me', 'change_task_status', {
                tasks: tasks.map((x: any) => {
                  return {
                    taskId: x._id,
                    status: 'concluidoAuto',
                  };
                }),
              });
            }

            if (promotedTasks.length >= maxPromotedTasks) {
              await actionLog('me', 'active_bonus', { task: newObj._id, stage: newObj.stageNumber });
            }

            await updateTask(newObj);
            return true;
          }
        } else {
          if (newObj.prosseguir_idGestor === playerInfo._id) {
            taskId = newObj._id;
            await updateTask(newObj);
            return true;
          } else {
            const tasks = [...(filteredData as any[])].filter((x: any) => {
              if (
                x._id !== newObj._id &&
                canReset(x) &&
                x.status === 'concluidoAuto' &&
                (getTaskStep(x) === getTaskStep(newObj) || getTaskStep(x) === getTaskStep(oldObj)) &&
                (oldObj?.status === 'promovido' || oldObj?.status === 'selo')
              ) {
                return true;
              }

              return false;
            });

            if (
              filteredData?.find(e => e._id === bonus?.taskId && e.stageNumber === bonus.stage) &&
              (oldObj?.status === 'promovido' || oldObj?.status === 'selo')
            ) {
              await actionLog('me', 'remove_action', { id: bonus?.action });
            } else if (tasks.length) {
              await actionLog('me', 'change_task_status', {
                tasks: tasks.map((x: any) => {
                  return {
                    taskId: x._id,
                    status: 'dobrado',
                  };
                }),
              });
            }

            await updateTask(newObj);
            return true;
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      await loadData(taskId);
      setPageLoading(false);
    }

    return null;
  }

  async function handleReset(task: any) {
    if (!canReset(task)) return false;

    const newObj = await loadData(task._id);

    delete newObj.evaluator;

    if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 4 &&
      activeStageObj &&
      activeStageObj.date_evaluation_step4_start &&
      realDatetime < activeStageObj.date_evaluation_step4_start
    ) {
      delete newObj.stageNumber;
      delete newObj.multiplicador;
      delete newObj.prosseguir_gst;
      delete newObj.prosseguir_idGestor;
      delete newObj.prosseguir_who_approved;

      newObj.status = 'aguardando';

      await deleteFeedbackByQuery(`taskId:'${newObj._id}'`);
    } else if (
      (String(task.original_manager) === String(playerInfo._id) ||
        (Array.isArray(playerInfo?.mad_dupla) &&
          playerInfo.mad_dupla.some((md: any) => md._id && md._id === String(task.original_manager)))) &&
      userCodEtapa(null, !!task.mad) === 5
    ) {
      delete newObj.stageNumber;
      delete newObj.multiplicador;
      delete newObj.prosseguir_gst;
      delete newObj.prosseguir_idGestor;
      delete newObj.prosseguir_who_approved;

      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        newObj.status = 'aguardando';
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep && getActiveEvaluationStep < 5) {
          newObj.status = 'aguardando';
        } else {
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        }
      }

      await deleteFeedbackByQuery(`taskId:'${newObj._id}'`);
    } else {
      if (getActiveEvaluationStep === 2) {
        delete newObj.stageNumber;
        delete newObj.multiplicador;
        delete newObj.prosseguir_gst;
        delete newObj.prosseguir_idGestor;
        delete newObj.prosseguir_who_approved;

        newObj.status = 'aguardando';

        await deleteFeedbackByQuery(`taskId:'${newObj._id}'`);
      } else {
        const playerId =
          Array.isArray(task.evaluator) && task.evaluator.includes(String(playerInfo._id))
            ? String(playerInfo._id)
            : Array.isArray(playerInfo.mad_dupla) &&
                Array.isArray(task.evaluator) &&
                playerInfo.mad_dupla.some((md: any) => task.evaluator.includes(String(md._id)))
              ? String(playerInfo.mad_dupla.find((md: any) => task.evaluator.includes(String(md._id)))._id)
              : null;

        if (playerId) {
          newObj.evaluator = [];

          for (let index = 0; index < task.evaluator.length; index++) {
            const id = task.evaluator[index];

            newObj.evaluator.push(id);

            if (id === playerId) {
              break;
            }
          }
        }

        if (getActiveEvaluationStep === 3) {
          delete newObj.prosseguir_gst;
          delete newObj.prosseguir_idGestor;
          delete newObj.prosseguir_who_approved;

          newObj.status = 'aprovado';
          newObj.multiplicador = 1;
          newObj.stageNumber = 1;
        } else if (getActiveEvaluationStep === 4) {
          delete newObj.prosseguir_gst;
          delete newObj.prosseguir_idGestor;
          delete newObj.prosseguir_who_approved;
          delete newObj.prosseguir_managers;

          newObj.status = 'promovido';
          newObj.multiplicador = 2;
          newObj.stageNumber = 2;
        } else if (getActiveEvaluationStep === 4.1) {
          delete newObj.prosseguir_who_approved;

          newObj.prosseguir_gst = 'next';
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        } else if (getActiveEvaluationStep === 5) {
          newObj.status = 'promovido';
          newObj.multiplicador = 4;
          newObj.stageNumber = 3;
        }

        if (!!newObj.feedback?.length) {
          let evaluators: any;

          if (Array.isArray(newObj.evaluator)) {
            evaluators = [newObj.original_manager, ...newObj.evaluator];
          } else {
            evaluators = [newObj.original_manager];
          }

          const evaluatorsWithoutMe = evaluators.filter((x: string) => x !== String(playerInfo._id));

          const feedbacksWithoutMe = newObj.feedback
            .filter((x: any) => {
              if (evaluatorsWithoutMe?.length) {
                const evaluatorId = x.evaluatorId.replace(/F(0+)?/g, '');
                return !evaluatorsWithoutMe.includes(evaluatorId);
              }

              return true;
            })
            .map((x: any) => x._id);

          if (feedbacksWithoutMe.length) {
            const deletedFeedbacks: any = [];

            feedbacksWithoutMe.forEach((feedbackId: string) =>
              deletedFeedbacks.push(deleteFeedbackByQuery(`_id:'${feedbackId}'`)),
            );

            await Promise.all(deletedFeedbacks);
          }
        }
      }
    }

    if (isVacationManager) {
      if (!newObj.substitute_managers) {
        newObj.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      newObj.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'reset',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('reset', newObj, task);
  }

  async function handleAccept(_item: any, gestor?: string) {
    const item = await loadData(_item._id);

    const managerTypeResult = CheckManagerType({
      user: { ...playerInfo, cod_etapa: userCodEtapa(playerInfo, !!item.mad) },
      item,
    });

    if (!!gestor || managerTypeResult !== 'equipe') {
      const valid = [...validTasks];
      valid.push(item);
      setValidTasks(valid);
    }

    const updatedData = { ...item };

    updatedData.status = 'aprovado';
    updatedData.multiplicador = updatedData.multiplicador || 1;
    updatedData.stageNumber = 1;

    if (managerTypeResult === 'equipe') {
      // Com BUG
      if (!gestor) {
        const nextManagers = await getNextManagers(item._id);
        setSelectedGestor({
          task: item,
          gestor: nextManagers[`nivel1`] && nextManagers[`nivel1`]._id ? nextManagers[`nivel1`]._id : playerInfo.gestor,
          cod: [1, 3],
        });
        setFunctionGestor(`handleAccept`);
        return;
      }

      if (!updatedData.evaluator) {
        updatedData.evaluator = [];
      }

      updatedData.evaluator.push(gestor);
      // updatedData.evaluator.push(
      //   nextManagers[`nivel1`] && nextManagers[`nivel1`]._id ? nextManagers[`nivel1`]._id : playerInfo.gestor,
      // );
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'aprovado',
        time: { $date: timestamp },
      });
    }

    if (!!gestor || managerTypeResult !== 'equipe') {
      setGetAction({ ...item, fuction: `validation-accept-${item._id}-finish` });
    }

    await updateAllTasks('accept', updatedData);
  }

  async function handleStop(_item: any) {
    const item = await loadData(_item._id);

    const managerTypeResult = CheckManagerType({
      user: { ...playerInfo, cod_etapa: userCodEtapa(playerInfo, !!item.mad) },
      item,
    });

    const updatedData = { ...item };

    if (
      updatedData.prosseguir_gst &&
      updatedData.prosseguir_gst === 'next' &&
      managerTypeResult === 'pitstop' &&
      updatedData.prosseguir_idGestor === playerInfo._id
    ) {
      updatedData.prosseguir_gst = 'stopped';
    }

    updatedData.status = 'concluido';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'concluido',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('stop', updatedData);
  }

  async function handleReject(_item: any) {
    const item = await loadData(_item._id);

    const rejected = [...rejectedTasks];
    rejected.push(item);
    setRejectedTasks(rejected);

    const updatedData = { ...item };
    updatedData.status = 'rejeitado';

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'rejeitado',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('reject', updatedData);
  }

  async function handleDoubled(_item: any) {
    const item = await loadData(_item._id);

    if (String(item.original_manager) === String(playerInfo._id) && userCodEtapa(null, !!item.mad) === 5) {
      // Presidente e vice-presidente
      if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
        return setModalCod5(item);
      } else {
        // Diretores e gerentes gerais
        if (getActiveEvaluationStep && getActiveEvaluationStep < 5) {
          return setModalCod5(item);
        }
      }
    }

    const doubled = [...doubledTasks];
    doubled.push(item);
    setDoubledTasks(doubled);

    let multiplicador = typeof item.multiplicador === 'number' ? item.multiplicador * 2 : 1;

    // const managerTypeResult = CheckManagerType({
    //   user: playerInfo,
    //   item,
    // });

    // if (managerTypeResult === 'solucoes') {
    //   multiplicador = 2;
    // } else if (managerTypeResult === 'executivo') {
    //   multiplicador = 4;
    // } else if (managerTypeResult === 'diretoria') {
    //   multiplicador = 8;
    // }

    const updatedData = { ...item };
    updatedData.status = 'dobrado';
    updatedData.multiplicador = multiplicador;

    if (!canPromote(updatedData, item)) {
      // if (!(userCodEtapa() === 4 && getActiveEvaluationStep === 2 && playerInfo.mad)) {
      updatedData.status = 'concluidoAuto';
      // }
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: 'dobrado',
        time: { $date: timestamp },
      });
    }

    await updateAllTasks('double', updatedData);
  }

  async function handlePromote(_item: any, gestor?: string, multiplicador?: number) {
    const item = await loadData(_item._id);

    const managerTypeResult = CheckManagerType({
      user: { ...playerInfo, cod_etapa: userCodEtapa(playerInfo, !!item.mad) },
      item,
    });

    const nextManagers = await getNextManagers(item._id);

    const promoted = [...promotedTasks];
    promoted.push(item);
    setPromotedTasks(promoted);

    const updatedData = { ...item };

    let stageNumber = updatedData.stageNumber;

    if (getTaskStep(item) === 3) {
      stageNumber = 2;
    } else if (typeof getTaskStep(item) === 'number' && (getTaskStep(item) as number) >= 4) {
      stageNumber = 3;
    }

    let managerProsseguir: null | string = null;

    if (playerInfo.prosseguir_gst === 1 && stageNumber === 3 && nextManagers && nextManagers.prosseguir && !isMAD(item)) {
      updatedData.prosseguir_gst = 'next';
      updatedData.prosseguir_idGestor = nextManagers.prosseguir._id;

      if (Array.isArray(updatedData.prosseguir_managers)) {
        updatedData.prosseguir_managers.push(updatedData.prosseguir_idGestor);
      } else {
        updatedData.prosseguir_managers = [updatedData.prosseguir_idGestor];
      }
    } else if (
      updatedData.prosseguir_gst &&
      updatedData.prosseguir_gst === 'next' &&
      managerTypeResult === 'pitstop' &&
      stageNumber === 3
    ) {
      // const lastManager = await playerLastManager(internalUser?.extra.id);

      managerProsseguir = nextManagers && nextManagers.nivel3 ? nextManagers.nivel3._id : playerInfo.gestor;

      updatedData.prosseguir_gst = 'approved';
      updatedData.prosseguir_who_approved = playerInfo._id;
    }

    updatedData.status = 'promovido';
    updatedData.stageNumber = stageNumber;

    if (!updatedData.evaluator) {
      updatedData.evaluator = [];
    }

    if (managerTypeResult === 'diretoria') {
      updatedData.multiplicador = multiplicador;
      updatedData.status = typeof multiplicador === 'number' && multiplicador >= 16 ? 'selo' : 'concluido';
      // updatedData.evaluator.push('Selo Missão Destaque');
    } else if (playerInfo.gestor || managerProsseguir) {
      if (typeof managerProsseguir === 'string') {
        updatedData.evaluator.push(managerProsseguir);
        setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
      } else {
        if (updatedData.prosseguir_gst === 'next') {
          updatedData.evaluator.push(updatedData.prosseguir_idGestor);
          setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
        } else {
          if (
            userCodEtapa(null, !!item.mad) === 4 &&
            String(updatedData.original_manager) === String(playerInfo._id) &&
            activeStageObj &&
            activeStageObj.date_evaluation_step4_start &&
            realDatetime < activeStageObj.date_evaluation_step4_start
          ) {
            setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
          } else if (!gestor) {
            setSelectedGestor({
              task: item,
              cod: stageNumber === 2 ? [4] : [5],
              gestor:
                nextManagers[`nivel${stageNumber}`] && nextManagers[`nivel${stageNumber}`]._id
                  ? nextManagers[`nivel${stageNumber}`]._id
                  : playerInfo.gestor,
            });
            setFunctionGestor(`handlePromote`);
            return;
          }

          updatedData.evaluator.push(gestor);

          // updatedData.evaluator.push(
          //   nextManagers[`nivel${stageNumber}`] && nextManagers[`nivel${stageNumber}`]._id
          //     ? nextManagers[`nivel${stageNumber}`]._id
          //     : playerInfo.gestor,
          // );
        }
      }
    }

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: updatedData.status,
        time: { $date: timestamp },
      });
    }

    if (
      userCodEtapa(null, !!item.mad) === 4 &&
      String(updatedData.original_manager) === String(playerInfo._id) &&
      getActiveEvaluationStep &&
      getActiveEvaluationStep < 4
    ) {
      delete updatedData.evaluator;
    }

    if (!!gestor) {
      setGetAction({ ...item, fuction: `validation-promote-${item._id}-finish` });
    }

    await updateAllTasks('promote', updatedData);
  }

  async function handleAward(_item: any, badge: 'uau' | 'mandou' | 'valeu') {
    const item = await loadData(_item._id);

    const status = badge === 'uau' ? 'selo' : badge;

    const updatedData = { ...item };
    updatedData.status = status;
    updatedData.multiplicador = status === 'selo' ? 16 : status === 'mandou' ? 8 : 5;

    if (isVacationManager) {
      if (!updatedData.substitute_managers) {
        updatedData.substitute_managers = [];
      }

      const timestamp = await getServerTime();

      updatedData.substitute_managers.push({
        playerId: user?._id,
        playerName: user?.name,
        status: status,
        time: { $date: timestamp },
      });
    }

    if (status === 'selo') {
      const arr = [...(Array.isArray(uauTasks) ? uauTasks : [])];
      arr.push(updatedData);
      setUauTasks(arr);
    } else if (status === 'mandou') {
      const arr = [...(Array.isArray(mandouBemTasks) ? mandouBemTasks : [])];
      arr.push(updatedData);
      setMandouBemTasks(arr);
    } else {
      const arr = [...(Array.isArray(valeuTasks) ? valeuTasks : [])];
      arr.push(updatedData);
      setValeuTasks(arr);
    }

    await updateAllTasks('award', updatedData);
  }

  // TO DO verificar cod_etapa 5 como gestor inicial
  async function handleSubmitCod5(item: any) {
    const task = await loadData(item._id);

    setModalCod5(undefined);

    let action = 'double';

    if (task.status === 'valeu' || task.status === 'mandou' || task.status === 'selo') {
      action = 'award';
    } else if (
      playerInfo.funcao_localizacao !== 3001 &&
      playerInfo.funcao_localizacao !== 3002 &&
      task.multiplicador === 4 &&
      task.stageNumber === 3 &&
      task.status === 'promovido' &&
      getActiveEvaluationStep &&
      getActiveEvaluationStep < 5
    ) {
      action = 'promote';
    }

    document.dispatchEvent(
      new CustomEvent('open:modal-feedback', {
        detail: {
          _id: task._id,
        },
      }),
    );
    await updateAllTasks(action, task);
  }

  const isCurrentEvaluator = useCallback(
    (task: any) => {
      if (!internalUser || !task || !playerInfo) return false;

      let evaluators = [];

      if (!!task.original_manager?.length) {
        evaluators.push(task.original_manager);
      }

      if (Array.isArray(task.evaluator) && task.evaluator?.length) {
        evaluators = evaluators.concat(task.evaluator);
      }

      evaluators = evaluators.filter(x => !x.match(/selo/gi));

      if (evaluators.length) {
        const matriculaEvaluator = parseInt(evaluators[evaluators.length - 1].replace('F', ''));
        const currentId = parseInt(playerInfo._id);
        const currentIdMad = Array.isArray(playerInfo.mad_dupla) ? playerInfo.mad_dupla.map((md: any) => parseInt(md._id)) : null;

        return matriculaEvaluator === currentId || (currentIdMad && currentIdMad.some((id: any) => matriculaEvaluator === id));
      } else {
        return false;
      }
    },
    [playerInfo, internalUser],
  );

  const tasksProsseguirAssessor: any[] = useMemo((): any[] => {
    if (!Array.isArray(filteredData) || !filteredData.length || !playerInfo) return [];

    const tasks = filteredData.filter(task => {
      if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) return true;

      if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return true;

      return false;
    });

    return tasks;
  }, [filteredData, playerInfo]);

  const hasRedeMAD: { rede: boolean; mad: boolean } | undefined = useMemo(() => {
    if (!Array.isArray(data) || !data.length || !playerInfo || !activeStageObj) return undefined;

    const obj = { rede: false, mad: false };

    const itemsByStage = data?.filter(item => {
      return item.created >= activeStageObj?.date_start && item.created <= activeStageObj?.date_finish;
    });

    if (itemsByStage.length) {
      if (userCodEtapa() && userCodEtapa() === 5 && activeStageObj?.type && activeStageObj?.type === 'semester') {
        obj.rede = !!itemsByStage.filter(
          (x: { prosseguir_gst: string; owner_tipo_classificacao: string }) =>
            (!!x.prosseguir_gst && x.prosseguir_gst === 'approved') ||
            (!!x.owner_tipo_classificacao && x.owner_tipo_classificacao === 'UNIDADE TÁTICA'),
        ).length;
      }

      obj.mad = !!itemsByStage.filter(x => !!x.mad || (Array.isArray(x.non_evaluator) && x.non_evaluator.length > 0)).length;
    }

    return obj;
  }, [activeStageObj, data, playerInfo, userCodEtapa]);

  const htmlCountdownStep = useMemo(() => {
    if (!activeStageObj || !playerInfo || activeStageObj.status === 'closed' || !realDatetime) return <></>;

    const itemsByStage: any[] = data?.length ? [...data] : [];
    const levelTitle = getActiveEvaluationStep
      ? getActiveEvaluationStep === 4.1
        ? 'Prosseguir'
        : getActiveEvaluationStep === 2
          ? 'Validação'
          : getActiveEvaluationStep === 3
            ? 'Nível 1'
            : getActiveEvaluationStep === 4
              ? 'Nível 2'
              : getActiveEvaluationStep === 5
                ? 'Nível 3'
                : null
      : null;

    if (itemsByStage.length) {
      const userTaskStep: number[] = itemsByStage?.map(task => getPlayerStep(task) as number).sort(() => -1);

      if (getActiveEvaluationStep && userTaskStep.includes(getActiveEvaluationStep)) {
        const date_finish =
          getActiveEvaluationStep === 2
            ? activeStageObj?.date_evaluation_step2_finish
            : getActiveEvaluationStep === 3
              ? activeStageObj?.date_evaluation_step3_finish
              : getActiveEvaluationStep === 4
                ? activeStageObj?.date_evaluation_step4_finish
                : getActiveEvaluationStep === 4.1
                  ? activeStageObj?.date_evaluation_pitStop_finish
                  : activeStageObj?.date_evaluation_step5_finish;

        return (
          <div className="py-4">
            {!!levelTitle && (
              <p className="text-xs text-alice-blue block font-thin">
                Fluxo de apreciação atual:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">{levelTitle}</strong>
              </p>
            )}
            <p className="text-xs text-alice-blue block font-thin">
              O período de apreciação deste nível termina em:{' '}
              <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                <Countdown key="missao" deadline={new Date(date_finish)} />
              </strong>
            </p>
          </div>
        );
      } else {
        if (getActiveEvaluationStep) {
          let hasAfter = userTaskStep?.find((x: number) => x > (getActiveEvaluationStep as number));

          const date_start =
            hasAfter === 2
              ? activeStageObj?.date_evaluation_step2_start
              : hasAfter === 3
                ? activeStageObj?.date_evaluation_step3_start
                : hasAfter === 4
                  ? activeStageObj?.date_evaluation_step4_start
                  : hasAfter === 4.1
                    ? activeStageObj?.date_evaluation_pitStop_start
                    : activeStageObj?.date_evaluation_step5_start;

          if (!!hasAfter && date_start && realDatetime < date_start) {
            return (
              <div className="py-4">
                <p className="text-xs text-alice-blue block font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </p>
              </div>
            );
          } else {
            return <></>;
          }
        } else {
          const date_start =
            realDatetime < activeStageObj?.date_evaluation_step2_start
              ? activeStageObj?.date_evaluation_step2_start
              : realDatetime < activeStageObj?.date_evaluation_step3_start
                ? activeStageObj?.date_evaluation_step3_start
                : realDatetime < activeStageObj?.date_evaluation_step4_start
                  ? activeStageObj?.date_evaluation_step4_start
                  : realDatetime < activeStageObj?.date_evaluation_pitStop_start
                    ? activeStageObj?.date_evaluation_pitStop_start
                    : realDatetime < activeStageObj?.date_evaluation_step5_start
                      ? activeStageObj?.date_evaluation_step5_start
                      : null;

          if (date_start && realDatetime < date_start) {
            return (
              <div className="py-4">
                <p className="text-xs text-alice-blue block font-thin">
                  O período de apreciação começa em:{' '}
                  <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                    <Countdown key="missao" deadline={new Date(date_start)} />
                  </strong>
                </p>
              </div>
            );
          } else {
            return <></>;
          }
        }
      }
    } else {
      const codEtapa =
        userCodEtapa(null, activeTabDirector === 'mad') === 2
          ? 2
          : userCodEtapa(null, activeTabDirector === 'mad') === 1 || userCodEtapa(null, activeTabDirector === 'mad') === 3
            ? 3
            : userCodEtapa(null, activeTabDirector === 'mad') === 4
              ? 4
              : userCodEtapa(null, activeTabDirector === 'mad') === 5
                ? 5
                : null;

      if (codEtapa) {
        if (getActiveEvaluationStep && getActiveEvaluationStep === codEtapa) {
          const date_finish =
            getActiveEvaluationStep === 2
              ? activeStageObj?.date_evaluation_step2_finish
              : getActiveEvaluationStep === 3
                ? activeStageObj?.date_evaluation_step3_finish
                : getActiveEvaluationStep === 4
                  ? activeStageObj?.date_evaluation_step4_finish
                  : activeStageObj?.date_evaluation_step5_finish;

          return (
            <div className="py-4">
              {!!levelTitle && (
                <p className="text-xs text-alice-blue block font-thin">
                  Fluxo de apreciação atual:{' '}
                  <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">{levelTitle}</strong>
                </p>
              )}
              <p className="text-xs text-alice-blue block font-thin">
                O período de apreciação deste nível termina em:{' '}
                <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                  <Countdown key="missao" deadline={new Date(date_finish)} />
                </strong>
              </p>
            </div>
          );
        } else {
          if (getActiveEvaluationStep && getActiveEvaluationStep < codEtapa) {
            const date_start =
              codEtapa === 2
                ? activeStageObj?.date_evaluation_step2_start
                : codEtapa === 3
                  ? activeStageObj?.date_evaluation_step3_start
                  : codEtapa === 4
                    ? activeStageObj?.date_evaluation_step4_start
                    : activeStageObj?.date_evaluation_step5_start;

            return (
              <div className="py-4">
                <p className="text-xs text-alice-blue block font-thin">
                  O período de apreciação começa em
                  {!!date_start ? (
                    <>
                      :{' '}
                      <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                        <Countdown key="missao" deadline={new Date(date_start)} />
                      </strong>
                    </>
                  ) : (
                    ' breve.'
                  )}
                </p>
              </div>
            );
          } else {
            const date_start =
              realDatetime < activeStageObj?.date_evaluation_step2_start && codEtapa === 2
                ? activeStageObj?.date_evaluation_step2_start
                : realDatetime < activeStageObj?.date_evaluation_step3_start && codEtapa === 3
                  ? activeStageObj?.date_evaluation_step3_start
                  : realDatetime < activeStageObj?.date_evaluation_step4_start && codEtapa === 4
                    ? activeStageObj?.date_evaluation_step4_start
                    : realDatetime < activeStageObj?.date_evaluation_pitStop_start && codEtapa === 5
                      ? activeStageObj?.date_evaluation_pitStop_start
                      : null;

            if (date_start && realDatetime < date_start) {
              return (
                <div className="py-4">
                  <p className="text-xs text-alice-blue block font-thin">
                    O período de apreciação começa em:{' '}
                    <strong className="text-xs text-alice-blue block font-normal whitespace-nowrap">
                      <Countdown key="missao" deadline={new Date(date_start)} />
                    </strong>
                  </p>
                </div>
              );
            } else {
              return <></>;
            }
          }
        }
      } else {
        return <></>;
      }
    }
  }, [activeStageObj, activeTabDirector, data, getActiveEvaluationStep, getPlayerStep, playerInfo, realDatetime, userCodEtapa]);

  useEffect(() => {
    async function updateData() {
      if (!hasRedeMAD) return setFilteredData([]);

      const isDirector = userCodEtapa(null, activeTabDirector === 'mad') && userCodEtapa(null, activeTabDirector === 'mad') === 5;

      try {
        let stageData: any = data?.filter(item => {
          return !!activeStageObj && item.created >= activeStageObj?.date_start && item.created <= activeStageObj?.date_finish;
        });

        if (activeStageObj?.type && activeStageObj?.type === 'semester') {
          stageData = stageData?.filter((item: any) => {
            const taskStep = getTaskStep(item);
            return (
              (taskStep !== undefined && taskStep >= 5) ||
              getPlayerStep(item) >= 5 ||
              (String(item.original_manager) === String(playerInfo._id) &&
                userCodEtapa(null, !!item.mad) &&
                userCodEtapa(null, !!item.mad) === 5)
            );
          });
        } else if (activeStageObj?.type && activeStageObj?.type === 'trimester') {
          stageData = stageData?.filter((item: any) => {
            const taskStep = getTaskStep(item);
            return (
              (taskStep !== undefined && taskStep >= 4 && taskStep < 5) ||
              (getPlayerStep(item) >= 4 && getPlayerStep(item) < 5) ||
              (String(item.original_manager) === String(playerInfo._id) &&
                userCodEtapa(null, !!item.mad) &&
                userCodEtapa(null, !!item.mad) === 4)
            );
          });
        }

        if (!stageData) stageData = [];

        if (hasRedeMAD.mad || hasRedeMAD.rede) {
          // const isMadOrNonEvaluator = (x: any) => !!x.mad || (Array.isArray(x.non_evaluator) && x.non_evaluator.length > 0);
          const isMadOrNonEvaluator = (x: any) => !!x.mad;

          if (activeTabDirector === 'rede') {
            stageData = stageData.filter(
              (x: any) =>
                (x.prosseguir_gst === 'approved' || x.owner_tipo_classificacao === 'UNIDADE TÁTICA') && !isMadOrNonEvaluator(x),
            );
          } else if (activeTabDirector === 'mad') {
            const tasksMAD = stageData.filter((x: any) => isMadOrNonEvaluator(x));

            if (!!pairSelected && pairSelected !== playerInfo?._id) {
              stageData = tasksMAD.filter((task: any) => {
                if (task.original_manager && task.original_manager === pairSelected) {
                  return true;
                }

                if (Array.isArray(task.evaluator) && !!task.evaluator.includes(pairSelected)) {
                  return true;
                }

                if (Array.isArray(task.non_evaluator) && !!task.non_evaluator.includes(pairSelected)) {
                  return true;
                }

                return false;
              });
            } else {
              const duoIds = Array.isArray(playerInfo.mad_dupla) ? playerInfo.mad_dupla.map((md: any) => md._id) : [];

              stageData = tasksMAD.filter((task: any) => {
                if (
                  duoIds.includes(task.original_manager) ||
                  (Array.isArray(task.evaluator) && task.evaluator.some((id: string) => duoIds.includes(id))) ||
                  (Array.isArray(task.non_evaluator) && task.non_evaluator.some((id: string) => duoIds.includes(id)))
                ) {
                  return false;
                }

                if (task.original_manager === playerInfo._id) {
                  return true;
                }
                if (Array.isArray(task.evaluator) && task.evaluator.includes(playerInfo._id)) {
                  return true;
                }
                if (Array.isArray(task.non_evaluator) && task.non_evaluator.includes(playerInfo._id)) {
                  return true;
                }

                return false;
              });
            }
          } else {
            stageData = hasRedeMAD.rede
              ? stageData.filter(
                  (x: any) => !x.prosseguir_gst && !isMadOrNonEvaluator(x) && x.owner_tipo_classificacao !== 'UNIDADE TÁTICA',
                )
              : stageData.filter((x: any) => !isMadOrNonEvaluator(x));
          }
        }

        const statuses: string[] = ['Selecione'];

        stageData.forEach((task: any) => {
          if (Array.isArray(task.statuses) && task.statuses.length) {
            task.statuses.forEach((_status: string) => {
              if (!statuses.find(x => x === _status)) {
                statuses.push(_status);
              }
            });
          }
        });

        setTasksStatus(statuses);

        let dataWithoutProsseguir = stageData;

        if (!isDirector) {
          dataWithoutProsseguir = stageData?.filter((task: any) => {
            if (!!task.prosseguir_idGestor && task.prosseguir_idGestor === playerInfo._id) return false;

            return true;
          });
        }

        setMaxValidTasks(stageData.length);

        setMaxRejectedTasks(stageData.length);

        setFeedbackTasks(
          stageData.filter((task: any) => {
            if (
              !!Array.isArray(task.feedback) &&
              !!task.feedback.find(
                (x: any) =>
                  (x.evaluatorId === user?._id && !x.original_task_manager?.playerId) ||
                  (x.original_task_manager?.playerId && x.original_task_manager?.playerId === user?._id) ||
                  (x.original_task_manager?.playerId &&
                    x.evaluatorId === user?._id &&
                    ((Array.isArray(task.evaluator_detail) && task.evaluator_detail.find((y: any) => y.chave === user?._id)) ||
                      (Array.isArray(task.non_evaluator_detail) &&
                        task.non_evaluator_detail.find((y: any) => y.chave === user?._id)))),
              )
            ) {
              return true;
            }

            return false;
          }).length,
        );

        const currentMaxDoubledTasks = dataWithoutProsseguir.filter((task: any) => {
          const _taskStep = getTaskStep(task);
          const date = +new Date();

          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          // Gestor imediato apreciando realização expirada
          if (
            taskAppreciationExpired(task) &&
            isVacationManager &&
            (userInfo?._id === playerInfo?.gestor ||
              (Array.isArray(userInfo?.mad_dupla) &&
                userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor))) &&
            activeStageObj &&
            isCurrentEvaluator(task)
          ) {
            if (
              !getActiveEvaluationStep &&
              ((userCodEtapa(userInfo, !!task.mad) === 4 && date < activeStageObj.date_evaluation_step4_start) ||
                (userCodEtapa(userInfo, !!task.mad) === 5 && date < activeStageObj.date_evaluation_step5_start))
            ) {
              return true;
            } else if (
              getActiveEvaluationStep &&
              ((getActiveEvaluationStep > 3 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!task.mad) === 4) ||
                (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!task.mad) === 5))
            ) {
              return true;
            }

            return false;
          }

          // Gestor imediato apreciando realização expirada
          if (
            isVacationManager &&
            (userInfo?._id === playerInfo?.gestor ||
              (Array.isArray(userInfo?.mad_dupla) &&
                userInfo?.mad_dupla?.some((md: any) => md._id && md._id === playerInfo?.gestor))) &&
            activeStageObj &&
            isCurrentEvaluator(task)
          ) {
            if (
              !getActiveEvaluationStep &&
              ((userCodEtapa(userInfo, !!task.mad) === 4 && date < activeStageObj.date_evaluation_step4_start) ||
                (userCodEtapa(userInfo, !!task.mad) === 5 && date < activeStageObj.date_evaluation_step5_start))
            ) {
              return true;
            } else if (
              getActiveEvaluationStep &&
              ((getActiveEvaluationStep > 2 && getActiveEvaluationStep <= 4 && userCodEtapa(userInfo, !!task.mad) === 4) ||
                (getActiveEvaluationStep > 4 && userCodEtapa(userInfo, !!task.mad) === 5))
            ) {
              return true;
            }

            return false;
          }

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            userCodEtapa(null, !!task.mad) &&
            userCodEtapa(null, !!task.mad) === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return true;
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return true;
              } else {
                return task.stageNumber === 3;
              }
            }
          }

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            userCodEtapa(null, !!task.mad) &&
            userCodEtapa(null, !!task.mad) === 4
          ) {
            if (
              typeof getActiveEvaluationStep === 'number' &&
              typeof _taskStep === 'number' &&
              (getActiveEvaluationStep === 2 || (getActiveEvaluationStep > 2 && _taskStep > 2))
            ) {
              return true;
            }

            return false;
          }

          if (
            task.status === 'rejeitado' ||
            taskAppreciationExpired(task) ||
            (typeof _taskStep === 'number' && typeof getPlayerStep(task) === 'number' && _taskStep < getPlayerStep(task)) ||
            (typeof _taskStep === 'number' &&
              typeof getActiveEvaluationStep === 'number' &&
              // String(task.original_manager) !== String(playerInfo._id) &&
              isCurrentEvaluator(task) &&
              ((getActiveEvaluationStep === 2 && _taskStep < 2) ||
                (getActiveEvaluationStep === 3 && _taskStep < 3) ||
                (getActiveEvaluationStep === 4 && _taskStep < 4) ||
                (getActiveEvaluationStep === 5 && _taskStep < 5))) ||
            (userCodEtapa(null, !!task.mad) &&
              userCodEtapa(null, !!task.mad) === 4 &&
              String(task.original_manager) === String(playerInfo._id) &&
              !canReset(task))
          )
            return false;

          return true;
        });
        setMaxDoubledTasks(currentMaxDoubledTasks.length);

        const stepFourCurrentMaxDoubledTasks = currentMaxDoubledTasks.filter((task: any) => {
          const _step = getPlayerStep(task);
          return _step && _step >= 4 && getActiveEvaluationStep && getActiveEvaluationStep >= 4;
        });

        const percent = stepFourCurrentMaxDoubledTasks?.length ? 0.2 : 0.1;

        setMaxPromotedTasks(
          currentMaxDoubledTasks.length ? clamp(Math.ceil(currentMaxDoubledTasks.length * percent), 1, Infinity) : 0,
        );

        const currentValidTasks = stageData.filter((item: any) => item.status !== 'rejeitado' && item.status !== 'aguardando');
        setValidTasks(currentValidTasks);

        const currentRejectedTasks = stageData.filter((item: any) => item.status === 'rejeitado');
        setRejectedTasks(currentRejectedTasks);

        const currentDoubledTasks = dataWithoutProsseguir.filter((task: any) => {
          const _taskStep = getTaskStep(task);

          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            userCodEtapa(null, !!task.mad) &&
            userCodEtapa(null, !!task.mad) === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return task.multiplicador && task.multiplicador > 1;
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return task.multiplicador && task.multiplicador > 1;
              } else {
                return task.multiplicador && task.multiplicador >= 8;
              }
            }
          }

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            userCodEtapa(null, !!task.mad) &&
            userCodEtapa(null, !!task.mad) === 4
          ) {
            if (
              typeof getActiveEvaluationStep === 'number' &&
              typeof task.multiplicador === 'number' &&
              ((getActiveEvaluationStep === 2 && task.stageNumber >= 2) || (getActiveEvaluationStep > 2 && task.stageNumber > 2))
            ) {
              return true;
            }

            return false;
          }

          if (typeof getTaskStep(task) === 'number' && (getTaskStep(task) as number) > 2) {
            if ((getTaskStep(task) as number) === 5 && getPlayerStep(task) === 5 && task.status === 'selo') {
              return true;
            }

            if ((getTaskStep(task) as number) > getPlayerStep(task)) {
              return true;
            }

            if (
              getActiveEvaluationStep &&
              userCodEtapa(null, !!task.mad) &&
              userCodEtapa(null, !!task.mad) === 4 &&
              String(task.original_manager) === String(playerInfo._id) &&
              (getTaskStep(task) as number) > getActiveEvaluationStep
            ) {
              return true;
            }

            return false;
          }

          return false;
        });
        setDoubledTasks(currentDoubledTasks);

        const currentPromotedTasks = dataWithoutProsseguir.filter((task: any) => {
          if (Array.isArray(task.prosseguir_managers) && !!task.prosseguir_managers.includes(playerInfo._id)) return false;

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            userCodEtapa(null, !!task.mad) &&
            userCodEtapa(null, !!task.mad) === 5 &&
            !!getActiveEvaluationStep
          ) {
            // Presidente e vice-presidente
            if (playerInfo.funcao_localizacao === 3001 || playerInfo.funcao_localizacao === 3002) {
              return task.status === 'selo';
            } else {
              // Diretores e gerentes gerais
              if (getActiveEvaluationStep < 5) {
                return task.status === 'promovido' && task.multiplicador === 4 && task.stageNumber === 3;
              } else {
                return task.status === 'selo';
              }
            }
          }

          if (
            String(task.original_manager) === String(playerInfo._id) &&
            userCodEtapa(null, !!task.mad) &&
            userCodEtapa(null, !!task.mad) === 4
          ) {
            if (
              typeof getActiveEvaluationStep === 'number' &&
              typeof task.multiplicador === 'number' &&
              ((getActiveEvaluationStep === 2 && task.stageNumber >= 2) || (getActiveEvaluationStep > 2 && task.stageNumber > 2))
            ) {
              return true;
            }

            return false;
          }

          if (typeof getTaskStep(task) === 'number' && (getTaskStep(task) as number) > 2) {
            if ((getTaskStep(task) as number) === 5 && getPlayerStep(task) === 5 && task.status === 'selo') {
              return true;
            }

            if ((getTaskStep(task) as number) > getPlayerStep(task)) {
              return true;
            }

            if (
              getActiveEvaluationStep &&
              userCodEtapa(null, !!task.mad) &&
              userCodEtapa(null, !!task.mad) === 4 &&
              String(task.original_manager) === String(playerInfo._id) &&
              (getTaskStep(task) as number) > getActiveEvaluationStep
            ) {
              return true;
            }

            return false;
          }

          return false;
        });
        setPromotedTasks(currentPromotedTasks);

        const _maxValeu = clamp(stageData.length, 1, Infinity);
        setMaxValeuTasks(_maxValeu);

        const _currentValeu = stageData.filter((x: { multiplicador: number; status: string; stageNumber: number }) => {
          return x.status === 'valeu';
        });
        setValeuTasks(_currentValeu);

        const _maxMandouBem = clamp(Math.ceil(stageData.length * 0.5), 1, Infinity);
        setMaxMandouBemTasks(_maxMandouBem);

        const _currentMandouBem = stageData.filter((x: { multiplicador: number; status: string; stageNumber: number }) => {
          return x.status === 'mandou';
        });
        setMandouBemTasks(_currentMandouBem);

        const _maxUau = clamp(Math.ceil(stageData.length * 0.25), 1, Infinity);
        setMaxUauTasks(_maxUau);

        const _currentUau = stageData.filter((x: { multiplicador: number; status: string; stageNumber: number }) => {
          return x.status === 'selo';
        });
        setUauTasks(_currentUau);

        setFilteredData(stageData);

        setLoading(false);
      } catch (e) {
        setFilteredData([]);
        setLoading(false);
      }
    }

    if (playerInfo) updateData();
  }, [
    activeStageObj,
    activeTabDirector,
    canReset,
    data,
    getActiveEvaluationStep,
    getPlayerStep,
    hasRedeMAD,
    isCurrentEvaluator,
    isVacationManager,
    playerInfo,
    taskAppreciationExpired,
    user?._id,
    userCodEtapa,
    userInfo,
    pairSelected,
  ]);

  function matchesSearch(item: any, search: string) {
    const fields = [
      item.description,
      item.owner,
      item.result,
      item.title,
      item.original_manager_detail?.chave,
      item.original_manager_detail?.nome,
    ];

    if (Array.isArray(item.evaluator_detail) && item.evaluator_detail.length) {
      item.evaluator_detail.forEach((ed: any) => {
        fields.push(ed.chave, ed.nome);
      });
    }

    if (Array.isArray(item.target) && item.target.length) {
      item.target.forEach((targetItem: any) => {
        fields.push(targetItem.name, targetItem._id);
      });
    }

    return fields.some(field => typeof field === 'string' && field.toLowerCase().includes(search));
  }

  useEffect(() => {
    if (Array.isArray(filteredData) && filteredData.length) {
      let _data = Array.isArray(filteredData) && filteredData.length ? filteredData : [];

      if (
        typeof selectedtasksStatus === 'string' &&
        selectedtasksStatus.length &&
        selectedtasksStatus.toLowerCase() !== 'selecione'
      ) {
        _data = _data.filter(x => !!x.statuses.includes(selectedtasksStatus));
      }

      if (typeof searchText === 'string' && searchText.trim().length) {
        const _search = searchText.replace(/ +/gi, ' ').trim().toLowerCase();
        _data = _data.filter(x => matchesSearch(x, _search));
      }

      setTasksByFilter(_data);
    } else {
      setTasksByFilter([]);
    }
  }, [filteredData, searchText, selectedtasksStatus]);

  useEffect(() => {
    if (!internalUser && !playerInfo) return;

    setLoading(true);
    getUserInfo();
  }, [getUserInfo, internalUser, playerInfo]);

  useEffect(() => {
    if (!gestor) return;

    setLoading(true);

    loadData();
  }, [gestor, loadData]);

  useEffect(() => {
    if (!stages) return;

    if (stages.length <= numberOfElements) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [numberOfElements, stages]);

  useEffect(() => {
    if (!getFullCalendar) return;

    if (getFullCalendar.length <= calendarNumberOfElements) {
      setCalendarShowMore(false);
    } else {
      setCalendarShowMore(true);
    }
  }, [calendarNumberOfElements, getFullCalendar]);

  useEffect(() => {
    try {
      const locationState: any = location.state;

      if (locationState && locationState.direction) {
        if (locationState.direction === 'back') {
          if (gestor) {
            loadData();
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [gestor, loadData, location]);

  useEffect(() => {
    if (!user) return;

    async function handleUser() {
      if (!!user) {
        const storedManager = getStorageItem('manager_lateralidade');

        if (!!storedManager && storedManager.length) {
          const vacationManagers = await findLateralMenagers(undefined, storedManager);

          const vacationManager = vacationManagers?.length
            ? vacationManagers.find((x: { _id: any }) => x._id === storedManager)
            : null;

          if (!!vacationManager?._id && !!vacationManager.extra?.id) {
            setInternalUser(vacationManager);
          } else {
            setInternalUser(user);
          }
        } else {
          setInternalUser(user);
        }
      }
    }

    async function handleUserWLoading() {
      setLoading(true);
      // console.log('handleUserWLoading');
      handleUser();
    }

    handleUser();

    document.addEventListener('reload:lateralidade', handleUserWLoading, false);

    return () => {
      document.removeEventListener('reload:lateralidade', handleUserWLoading);
    };
  }, [user]);

  // const processCurrentStage = useCallback(() => {
  //   // const _stages = realCycle?.find(x => x._id === activeCycleSelected)?.steps;
  //   // setStages(_stages);
  //   // const _stageActive = _stages?.find((item: any) => item.status === 'evaluation') || (_stages && _stages[0]);
  //   // const _id =
  //   //   !!_stageActive &&
  //   //   realDatetime >= _stageActive?.date_evaluation_step5_start &&
  //   //   realDatetime <= _stageActive?.date_evaluation_step5_finish
  //   //     ? 'semestral'
  //   //     : !!_stageActive &&
  //   //         realDatetime >= _stageActive?.date_evaluation_step4_start &&
  //   //         realDatetime <= _stageActive?.date_evaluation_step4_finish
  //   //       ? 'trimestral'
  //   //       : _stageActive?._id;
  //   // setCurrentStage(!!_id ? _id : Array.isArray(_stages) ? _stages[0]._id : undefined);
  //   // setEvaluateStage(_stageActive);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [activeCycleSelected, realCycle]);

  // useEffect(() => {
  //   if (!activeCycleSelected || !realCycle || !hasTime) return;
  //   processCurrentStage();
  // }, [activeCycleSelected, realCycle, hasTime, processCurrentStage]);

  const configCycleAndStage = useCallback(() => {
    if (!user || !cyclesExtended || !internalUser || typeof currentCycle !== 'undefined' || typeof currentStage !== 'undefined')
      return;

    const cycleOptions = cyclesExtended.map((cycle: any) => {
      cycle.label = 'Ciclo ' + cycle.title;
      cycle.value = cycle._id;

      return cycle;
    });

    const cycleActive = cyclesExtended.find(x => x._id === cycleSelected?._id);
    const _currentCycle = !!cycleActive ? cycleActive._id : cyclesExtended[0]._id;

    setOptionsCycle(cycleOptions);
    setCurrentCycle(_currentCycle);
    setActiveCycleSelected(cycleSelected?._id ? cycleSelected?._id : _currentCycle);

    const _stages = cyclesExtended?.find(x => x._id === _currentCycle)?.steps;
    setStages(_stages);

    const _stageActive = _stages?.find((item: any) => item.status === 'evaluation')
      ? _stages?.find((item: any) => item.status === 'evaluation')
      : _stages?.find((item: any) => item.type && item.type === 'month' && item.status === 'open')
        ? _stages?.find((item: any) => item.type && item.type === 'month' && item.status === 'open')
        : _stages && _stages.filter(item => item.type === 'month')[0];

    const indexOf =
      (Array.isArray(_stages) && _stages?.map(x => x._id).indexOf(_stageActive?._id as string) + 1 > 3
        ? _stages?.map(x => x._id).indexOf(_stageActive?._id as string) + 1
        : 3) || 3;

    setElementsIndexOf(indexOf);
    setNumberOfElements(indexOf);

    setCurrentStage(_stageActive?._id);
  }, [currentCycle, currentStage, cycleSelected?._id, cyclesExtended, internalUser, user]);

  useEffect(() => {
    if (!user || !cyclesExtended) return;

    configCycleAndStage();
  }, [configCycleAndStage, cyclesExtended, user]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  function isMAD(task: any): boolean {
    if (!task) return false;
    return !!task.mad || (Array.isArray(task.non_evaluator) && task.non_evaluator.length > 0);
  }

  const functionsObject: any = {
    handleAccept,
    handlePromote,
  };

  useEffect(() => {
    if (params?.id) return;

    if (cycleSelected) {
      if (cycleSelected?.version && cycleSelected?.version !== 'v3') {
        navigate(`/${cycleSelected.version}/minha-equipe/validar-apreciar-realizacao`);
      } else {
        navigate(`/minha-equipe/validar-apreciar-realizacao`);
      }
    }
  }, [cycleSelected, navigate, params.id]);

  if (
    !user ||
    !internalUser ||
    typeof gestor !== 'boolean' ||
    typeof currentCycle === 'undefined' ||
    typeof currentStage === 'undefined' ||
    !activeStageObj
  )
    return null;

  if (!gestor && !loading) {
    return (
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex flex-row items-center space-x-4 mb-16">
          <div>
            <Link to="../">
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>
          </div>
          <h1 className="text-xl lg:text-3xl text-white font-semibold">Realização Destaque</h1>
        </div>

        <div className="border-2 border-electric-blue rounded-3xl p-8 bg-oxford-blue">
          <p className="text-dandelion text-lg font-semibold block text-center">Você não possui acesso à esta página.</p>
        </div>
      </div>
    );
  }

  if (showDetail) return <Detail onClose={() => setShowDetail(false)} />;

  if (user?.extra.rede) return <NotFound />;

  return (
    <>
      {!!pageLoading && (
        <div className="fixed z-40 w-full h-full top-0 left-0 block flex items-center justify-center bg-black bg-opacity-60">
          <div role="status" className="flex items-center justify-center flex-col space-y-2 text-white">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span className="text-white">Carregando...</span>
          </div>
        </div>
      )}

      <main className="mx-auto container p-3 lg:p-10 overflow-hidden" aria-busy={loading}>
        <Header
          isRoot={true}
          onSubmitSearch={function (id: any): void {
            console.log(id);
          }}
        />

        {/* <div className={`flex flex-row items-center space-x-4 mb-16`}>
          <div>
            <Link to="../">
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>
          </div>
          <h1 className="text-xl lg:text-3xl text-white font-semibold">Realização Destaque</h1>
        </div> */}

        {!!isVacationManager && !!internalUser && (
          <div className="border-2 border-electric-blue rounded-3xl px-8 py-6 mb-12 bg-rich-black bg-opacity-80 ">
            <p className="text-dandelion text-lg font-semibold block mb-3">
              Você está {userCodEtapa() && userCodEtapa() === 2 ? 'validando' : 'apreciando'} por:
            </p>

            <div className="flex flex-row items-center space-x-4">
              <div className="w-[44px] h-[44px]">
                <UserAvatar
                  data={{
                    image: internalUser.image,
                    ...internalUser.extra,
                  }}
                />
              </div>
              <p>
                <span className="text-xs font-thin">
                  <strong className="text-base font-semibold">{internalUser.name}</strong> ({internalUser._id})
                </span>
                <span className="block text-xs font-thin">
                  <span className="text-electric-blue uppercase">{internalUser.extra?.dependencia}</span> -{' '}
                  {internalUser.extra?.funcao}
                </span>
              </p>
              <Link
                to="/"
                className={`!ml-8 leading-none ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white hover:text-white hover:no-underline no-underline rounded py-2 px-3`}
              >
                SAIR
              </Link>
            </div>
          </div>
        )}

        <div className="border-2 border-electric-blue rounded-3xl px-8 py-6 mb-12 bg-oxford-blue" role="region" aria-labelledby="clarifying-heading">
          <h1 id="clarifying-heading" className="sr-only">Orientações sobre apreciação de realizações</h1>
          {clarifyingText}
        </div>

        <div className="w-full flex flex-col lg:flex-row lg:justify-between">
          <div className="lg:w-[32.5%]">
            <div className="mb-5">
              <h2 className="text-xl text-white block mb-6 font-semibold">Histórico de Realizações</h2>

              <Box>
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 mb-8">
                      <div>
                        <p className="mb-2">Escolha o ciclo que deseja acompanhar</p>

                        {optionsCycle && (
                          <div className="mb-4">
                            <CustomSelect
                              placeholder="Clique para selecionar o ciclo"
                              options={optionsCycle}
                              onChange={(e: any) => {
                                setActiveCycleSelected(e.value);
                                setCurrentCycle(undefined);
                                setCurrentStage(undefined);

                                const selected = cyclesExtended?.find(x => x._id === e.value);

                                if (selected) {
                                  setCycleSelected({
                                    _id: selected._id,
                                    title: selected.title,
                                    version: GetVersion(selected.date_start),
                                  });
                                }
                              }}
                              value={
                                optionsCycle.find(x => x.value === cycleSelected?._id)
                                  ? optionsCycle.find(x => x.value === cycleSelected?._id)
                                  : optionsCycle[getIndexByValue(optionsCycle, activeCycleSelected)]
                              }
                            />
                          </div>
                        )}
                      </div>

                      <p className="text-white mb-8 text-base font-normal block">Escolha a fase</p>

                      <ul className="space-y-4 flex flex-col">
                        {stages &&
                          stages.slice(0, numberOfElements).map((cycle: any) => {
                            return (
                              <li key={cycle._id}>
                                <button
                                  className={`${
                                    currentStage === cycle._id ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                  } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                  onClick={() => setCurrentStage(cycle._id)}
                                  aria-label={`Selecionar fase ${cycle.title}`}
                                >
                                  {cycle.title}
                                  {/* {GetTaskStatusLabel(cycle.status)} */}
                                </button>
                              </li>
                            );
                          })}

                        {!!stages && stages?.length > (elementsIndexOf as number) && (
                          <button
                            className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                            onClick={() =>
                              !showMore
                                ? setNumberOfElements(elementsIndexOf as number)
                                : setNumberOfElements(numberOfElements + 3)
                            }
                          >
                            {!showMore ? (
                              <>
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver menos</span>
                              </>
                            ) : (
                              <>
                                <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver mais</span>
                              </>
                            )}
                          </button>
                        )}
                      </ul>
                    </div>

                    {activeStageObj?._id !== '68af4da8458e527eaa788503' ? (
                      <>
                        {activeStageObj?.status === 'open' ||
                        (getActiveEvaluationStep &&
                          ((getActiveEvaluationStep === 5 && activeStageObj?.type && activeStageObj?.type === 'semester') ||
                            (getActiveEvaluationStep >= 4 &&
                              getActiveEvaluationStep < 5 &&
                              activeStageObj?.type &&
                              activeStageObj?.type === 'trimester') ||
                            (getActiveEvaluationStep < 4 && activeStageObj?.type && activeStageObj?.type === 'month'))) ||
                        (isDirectManager &&
                          (userCodEtapa(userInfo) === 1 ||
                            userCodEtapa(userInfo) === 3 ||
                            userCodEtapa(userInfo) === 4 ||
                            userCodEtapa(userInfo) === 5)) ? (
                          <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                            <p className="block text-white leading-none font-normal text-base">
                              Realizações da Fase {getMonthNameFromString(activeStageObj?.title)}
                            </p>

                            {(!!hasRedeMAD?.mad || !!hasRedeMAD?.rede) && (
                              <div className="flex items-center justify-between">
                                <button
                                  className={`${
                                    activeTabDirector === 'diretoria' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                  } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue ${!!hasRedeMAD?.mad && !!hasRedeMAD?.rede ? 'rounded-none' : 'rounded'} w-[45%] h-10`}
                                  onClick={() => setActiveTabDirector('diretoria')}
                                >
                                  Diretoria
                                </button>

                                {!!hasRedeMAD?.mad && (
                                  <button
                                    className={`${
                                      activeTabDirector === 'mad' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                    } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue ${!!hasRedeMAD?.mad && !!hasRedeMAD?.rede ? 'rounded-none' : 'rounded'} w-[45%] h-10`}
                                    onClick={() => setActiveTabDirector('mad')}
                                  >
                                    MAD
                                  </button>
                                )}

                                {!!hasRedeMAD?.rede && (
                                  <button
                                    className={`${
                                      activeTabDirector === 'rede' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                    } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue ${!!hasRedeMAD?.mad && !!hasRedeMAD?.rede ? 'rounded-none' : 'rounded'} w-[45%] h-10`}
                                    onClick={() => setActiveTabDirector('rede')}
                                  >
                                    Rede
                                  </button>
                                )}
                              </div>
                            )}

                            {!!hasRedeMAD?.mad && activeTabDirector === 'mad' && Array.isArray(playerInfo.mad_dupla) ? (
                              <>
                                <div className="mb-4">
                                  <p className="text-yellow font-normal">Selecione sua dupla:</p>
                                  <div>
                                    <CustomSelect
                                      placeholder="Clique para selecionar a dupla"
                                      options={optionsPairs}
                                      onChange={(e: any) => {
                                        setPairSelected(e.value);
                                      }}
                                      value={pairSelected ? optionsPairs.find(x => x.value === pairSelected) : optionsPairs[0]}
                                      className="teste"
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {activeStageObj && activeStageObj.status === 'open' ? (
                              <>
                                <div>
                                  <p className="text-xs text-alice-blue block font-thin">
                                    O período de apreciação desta fase inicia em:
                                  </p>
                                  <div className="text-xs text-alice-blue block font-normal">
                                    <Countdown key="missao" deadline={new Date(activeStageObj.date_finish)} />
                                  </div>
                                </div>
                              </>
                            ) : null}

                            {getActiveEvaluationStep ||
                            (isDirectManager &&
                              (userCodEtapa(userInfo) === 1 ||
                                userCodEtapa(userInfo) === 3 ||
                                userCodEtapa(userInfo) === 4 ||
                                userCodEtapa(userInfo) === 5)) ? (
                              <>
                                {getActiveEvaluationStep &&
                                ((getActiveEvaluationStep === 5 &&
                                  userCodEtapa(userInfo) === 5 &&
                                  activeStageObj?.type &&
                                  activeStageObj?.type === 'semester') ||
                                  ((getActiveEvaluationStep === 4 || getActiveEvaluationStep === 4.1) &&
                                    (userCodEtapa(userInfo) === 4 || userCodEtapa(userInfo) === 5) &&
                                    activeStageObj?.type &&
                                    activeStageObj?.type === 'trimester') ||
                                  (getActiveEvaluationStep < 4 &&
                                    userCodEtapa(userInfo) < 4 &&
                                    activeStageObj?.type &&
                                    activeStageObj?.type === 'month') ||
                                  (isDirectManager &&
                                    (userCodEtapa(userInfo) === 1 ||
                                      userCodEtapa(userInfo) === 3 ||
                                      userCodEtapa(userInfo) === 4 ||
                                      userCodEtapa(userInfo) === 5))) ? (
                                  <>
                                    {!!isOriginalManager ? (
                                      <>
                                        {!!maxValidTasks && (
                                          <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                            <HiOutlineHandThumbUp className="text-xl" />
                                            <span className="flex-1 text-white text-xs leading-none font-thin">
                                              Total de realizações validadas
                                            </span>
                                            <div className="text-right text-yellow font-normal leading-none text-base">
                                              {validTasks?.length || 0}/{maxValidTasks || 0}
                                            </div>
                                          </div>
                                        )}

                                        {!!maxRejectedTasks && (
                                          <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                            <HiOutlineHandThumbDown className="text-xl" />
                                            <span className="flex-1 text-white text-xs leading-none font-thin">
                                              Total de realizações devolvidas
                                            </span>
                                            <div className="text-right text-yellow font-normal leading-none text-base">
                                              {rejectedTasks?.length || 0}/{maxRejectedTasks || 0}
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {!!isOriginalManagerCod5 ||
                                    (userCodEtapa() &&
                                      userCodEtapa() !== 2 &&
                                      userCodEtapa() < 5 &&
                                      getActiveEvaluationStep &&
                                      getActiveEvaluationStep > 2) ||
                                    (userCodEtapa() && userCodEtapa() !== 2 && userCodEtapa() < 5 && isDirectManager) ? (
                                      <>
                                        {!!maxDoubledTasks && (
                                          <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                            <FaCoins className="text-xl" />
                                            <span className="flex-1 text-white text-xs leading-none font-thin">
                                              Total de realizações bonificadas
                                            </span>
                                            <div className="text-right text-yellow font-normal leading-none text-base">
                                              {doubledTasks?.length || 0}/{maxDoubledTasks || 0}
                                            </div>
                                          </div>
                                        )}

                                        {userCodEtapa() !== 5 && !!maxPromotedTasks && (
                                          <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                            {userCodEtapa() === 5 &&
                                            (getActiveEvaluationStep === 5 ||
                                              playerInfo.funcao_localizacao === 3001 ||
                                              playerInfo.funcao_localizacao === 3002 ||
                                              !isOriginalManager) ? (
                                              <TfiMedallAlt className="text-xl" />
                                            ) : (
                                              <BiUpvote className="text-xl" />
                                            )}
                                            <span className="flex-1 text-white text-xs leading-none font-thin">
                                              {userCodEtapa() === 5 &&
                                              (getActiveEvaluationStep === 5 ||
                                                playerInfo.funcao_localizacao === 3001 ||
                                                playerInfo.funcao_localizacao === 3002 ||
                                                !isOriginalManager)
                                                ? 'Total de selos concedidos'
                                                : 'Total de realizações promovidas'}
                                            </span>
                                            <div className="text-right text-yellow font-normal leading-none text-base">
                                              {promotedTasks?.length || 0}/{maxPromotedTasks || 0}
                                            </div>
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {tasksProsseguirAssessor.length ? (
                                      <>
                                        <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                          <BiUpvote className={`text-xl rotate-90 transform`} />
                                          <span className="flex-1 text-white text-xs leading-none font-thin">
                                            Total de realizações enviadas para apreciação da diretoria
                                          </span>
                                          <div className="text-right text-yellow font-normal leading-none text-base">
                                            {
                                              /* Mudar isso. Filtrar excluindo o prosseguir_idGestor do prosseguir_managers e verificar se o id do usuário existe */
                                              tasksProsseguirAssessor.filter(item => {
                                                return (
                                                  (item.prosseguir_who_approved &&
                                                    item.prosseguir_who_approved === internalUser?.extra.id) ||
                                                  (Array.isArray(item.prosseguir_managers) &&
                                                    item.prosseguir_managers.length >= 2 &&
                                                    item.prosseguir_managers[0] === playerInfo._id)
                                                );
                                              }).length
                                            }
                                            /{tasksProsseguirAssessor.length}
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <></>
                                    )}

                                    {userCodEtapa() === 5 && activeStageObj?.type && activeStageObj?.type === 'semester' ? (
                                      <>
                                        <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                          <PiThumbsUpLight className="text-xl" />
                                          <span className="flex-1 text-white text-xs leading-none font-thin">
                                            Total de realizações Valeu
                                          </span>
                                          <div className="text-right text-yellow font-normal leading-none text-base">
                                            {valeuTasks?.length || 0}/{maxValeuTasks || 0}
                                          </div>
                                        </div>

                                        <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                          <PiHandsClappingLight className="text-xl" />
                                          <span className="flex-1 text-white text-xs leading-none font-thin">
                                            Total de realizações Mandou Bem
                                          </span>
                                          <div className="text-right text-yellow font-normal leading-none text-base">
                                            {mandouBemTasks?.length || 0}/{maxMandouBemTasks || 0}
                                          </div>
                                        </div>

                                        <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                          <FaRegGrinStars className="text-xl" />
                                          <span className="flex-1 text-white text-xs leading-none font-thin">
                                            Total de realizações Uau
                                          </span>
                                          <div className="text-right text-yellow font-normal leading-none text-base">
                                            {uauTasks?.length || 0}/{maxUauTasks || 0}
                                          </div>
                                        </div>
                                      </>
                                    ) : null}

                                    <div className="space-x-3 flex flex-row items-center justify-between pt-4 border-t border-prussian-blue-2">
                                      <BsChatText className="text-xl" />
                                      <span className="flex-1 text-white text-xs leading-none font-thin">
                                        Total de feedbacks concedidos
                                      </span>
                                      <div className="text-right text-yellow font-normal leading-none text-base">
                                        {feedbackTasks}/{maxValidTasks}
                                      </div>
                                    </div>
                                  </>
                                ) : null}
                              </>
                            ) : null}
                          </div>
                        ) : !!hasRedeMAD?.mad || !!hasRedeMAD?.rede ? (
                          <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                            <div className="flex items-center justify-between">
                              <button
                                className={`${
                                  activeTabDirector === 'diretoria' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-[45%] h-10`}
                                onClick={() => setActiveTabDirector('diretoria')}
                              >
                                Diretoria
                              </button>

                              {!!hasRedeMAD?.mad && (
                                <button
                                  className={`${
                                    activeTabDirector === 'mad' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                  } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-[45%] h-10`}
                                  onClick={() => setActiveTabDirector('mad')}
                                >
                                  MAD
                                </button>
                              )}

                              {!!hasRedeMAD?.rede && (
                                <button
                                  className={`${
                                    activeTabDirector === 'rede' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                  } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-[45%] h-10`}
                                  onClick={() => setActiveTabDirector('rede')}
                                >
                                  Rede
                                </button>
                              )}
                            </div>

                            {!!hasRedeMAD?.mad && activeTabDirector === 'mad' && Array.isArray(playerInfo.mad_dupla) ? (
                              <>
                                <div className="mb-4">
                                  <p className="text-yellow font-normal">Selecione sua dupla:</p>
                                  <div>
                                    <CustomSelect
                                      placeholder="Clique para selecionar a dupla"
                                      options={optionsPairs}
                                      onChange={(e: any) => {
                                        setPairSelected(e.value);
                                      }}
                                      value={pairSelected ? optionsPairs.find(x => x.value === pairSelected) : optionsPairs[0]}
                                      className="teste"
                                    />
                                  </div>
                                </div>
                              </>
                            ) : null}
                          </div>
                        ) : null}
                      </>
                    ) : null}

                    {/* {canShowBonus && (
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4 mt-5">
                        <p className="block text-white leading-none font-normal text-base">Carta Reconhecer+</p>
                        <div className="space-x-3 flex flex-row items-center justify-between">
                          <img src={CardIcon} alt="" />
                          <span className="flex-1 text-white text-xs leading-none font-thin">
                            Total de realizações promovidas pela carta Reconhecer+
                          </span>
                          <div className="text-right text-yellow font-normal leading-none text-base">
                            {bonus?.isUsed ? 1 : 0}/{bonus?.hasBonus ? 1 : 0}
                          </div>
                        </div>
                      </div>
                    )} */}
                  </>
                )}
              </Box>
            </div>

            {!!getFullCalendar && activeStageObj?._id !== '68af4da8458e527eaa788503' && (
              <div className="pt-3">
                <h2 className="text-xl text-white block mb-6 font-semibold">Calendário</h2>

                <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                  {loading ? (
                    <div className="grid grid-cols-1 gap-3">
                      <ArticlePlaceholder />
                    </div>
                  ) : (
                    <>
                      <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                        {/* <p className="block text-white leading-none font-normal text-base pb-2">Fase {activeStageObj?.title}</p> */}

                        <div className="font-thin">
                          {getFullCalendar.slice(0, calendarNumberOfElements).map((item, idx) => (
                            <p className={idx === 0 ? 'm-0' : `pt-2 mt-2 border-t border-prussian-blue-2`} key={item.title}>
                              <span className="text-yellow font-light">
                                {format(item.start, 'dd/MM')} a {format(subMinutes(item.end, 10), 'dd/MM')}:
                              </span>{' '}
                              {item.stage} - <span className="text-blue-light font-light">{item.period}</span>
                            </p>
                          ))}

                          {!!getFullCalendar && getFullCalendar?.length > (calendarElementsIndexOf as number) && (
                            <button
                              className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                              onClick={() =>
                                !calendarShowMore
                                  ? setCalendarNumberOfElements(calendarElementsIndexOf as number)
                                  : setCalendarNumberOfElements(calendarNumberOfElements + 5)
                              }
                            >
                              {!calendarShowMore ? (
                                <>
                                  <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                                  <span className="uppercase">Ver menos</span>
                                </>
                              ) : (
                                <>
                                  <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                  <span className="uppercase">Ver mais</span>
                                </>
                              )}
                            </button>
                          )}

                          {/* {!!activeStageObj &&
                            activeStageObj?.type &&
                            activeStageObj?.type === 'month' &&
                            activeStageObj.date_start &&
                            activeStageObj.date_finish && (
                              <>
                                <p className="m-0">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj.date_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj.date_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Cadastramento
                                </p>

                                {!!activeStageObj.date_evaluation_step2_start &&
                                  !!activeStageObj.date_evaluation_step2_finish && (
                                    <p className="pt-2 mt-2 border-t border-prussian-blue-2">
                                      <span className="text-yellow font-light">
                                        {format(activeStageObj.date_evaluation_step2_start, 'dd/MM')} a{' '}
                                        {format(subMinutes(activeStageObj.date_evaluation_step2_finish, 10), 'dd/MM')}:
                                      </span>{' '}
                                      Validação (Líderes imediatos)
                                    </p>
                                  )}

                                {!!activeStageObj.date_evaluation_step3_start &&
                                  !!activeStageObj.date_evaluation_step3_finish && (
                                    <p className="pt-2 mt-2 border-t border-prussian-blue-2">
                                      <span className="text-yellow font-light">
                                        {format(activeStageObj.date_evaluation_step3_start, 'dd/MM')} a{' '}
                                        {format(subMinutes(activeStageObj.date_evaluation_step3_finish, 10), 'dd/MM')}:
                                      </span>{' '}
                                      Apreciação Nível 1
                                    </p>
                                  )}

                                {!!activeStageObj.date_evaluation_step4_start &&
                                  !!activeStageObj.date_evaluation_step4_finish && (
                                    <p className="pt-2 mt-2 border-t border-prussian-blue-2">
                                      <span className="text-yellow font-light">
                                        {format(activeStageObj.date_evaluation_step4_start, 'dd/MM')} a{' '}
                                        {format(subMinutes(activeStageObj.date_evaluation_step4_finish, 10), 'dd/MM')}:
                                      </span>{' '}
                                      Apreciação Nível 2
                                    </p>
                                  )}

                                {!!activeStageObj.date_evaluation_pitStop_start &&
                                  !!activeStageObj.date_evaluation_pitStop_finish && (
                                    <p className="pt-2 mt-2 border-t border-prussian-blue-2">
                                      <span className="text-yellow font-light">
                                        {format(activeStageObj.date_evaluation_pitStop_start, 'dd/MM')} a{' '}
                                        {format(subMinutes(activeStageObj.date_evaluation_pitStop_finish, 10), 'dd/MM')}:
                                      </span>{' '}
                                      Prosseguir
                                    </p>
                                  )}

                                {!!activeStageObj.date_evaluation_step5_start &&
                                  !!activeStageObj.date_evaluation_step5_finish && (
                                    <p className="pt-2 mt-2 border-t border-prussian-blue-2">
                                      <span className="text-yellow font-light">
                                        {format(activeStageObj.date_evaluation_step5_start, 'dd/MM')} a{' '}
                                        {format(subMinutes(activeStageObj.date_evaluation_step5_finish, 10), 'dd/MM')}:
                                      </span>{' '}
                                      Apreciação Nível 3 (Gerentes Gerais UE e Diretores)
                                    </p>
                                  )}
                              </>
                            )}

                          {activeStageObj?.type &&
                            activeStageObj?.type === 'trimester' &&
                            !!activeStageObj.date_evaluation_step4_start &&
                            !!activeStageObj.date_evaluation_step4_finish && (
                              <>
                                <p className="m-0">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj.date_evaluation_step4_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj.date_evaluation_step4_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Apreciação Nível 2
                                </p>

                                {!!activeStageObj.date_evaluation_pitStop_start &&
                                  !!activeStageObj.date_evaluation_pitStop_finish && (
                                    <p className="pt-2 mt-2 border-t border-prussian-blue-2">
                                      <span className="text-yellow font-light">
                                        {format(activeStageObj.date_evaluation_pitStop_start, 'dd/MM')} a{' '}
                                        {format(subMinutes(activeStageObj.date_evaluation_pitStop_finish, 10), 'dd/MM')}:
                                      </span>{' '}
                                      Prosseguir
                                    </p>
                                  )}
                              </>
                            )}

                          {activeStageObj?.type &&
                            activeStageObj?.type === 'semester' &&
                            !!activeStageObj.date_evaluation_step5_start &&
                            !!activeStageObj.date_evaluation_step5_finish && (
                              <>
                                <p className="m-0">
                                  <span className="text-yellow font-light">
                                    {format(activeStageObj.date_evaluation_step5_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeStageObj.date_evaluation_step5_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Apreciação Nível 3 (Gerentes Gerais UE e Diretores)
                                </p>
                              </>
                            )} */}
                        </div>
                      </div>
                    </>
                  )}
                </Box>
              </div>
            )}

            <div className="pt-6">
              <h2 className="text-xl text-white block mb-6 font-semibold">Realizações da sua unidade</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 flex flex-col items-center">
                      <p className="mb-5">Deseja acompanhar as Realizações Destaque cadastradas pelos colegas da sua unidade?</p>

                      <button
                        className={`text-white text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                        onClick={() => setShowDetail(true)}
                      >
                        ver realizações
                      </button>
                    </div>
                  </>
                )}
              </Box>
            </div>
          </div>

          <div className="lg:w-[64.8%]">
            <div className="mb-3 flex items-center justify-between mb-6">
              <h2 className="text-xl text-white block m-0 font-semibold flex-1">
                Realizações
                {!loading && filteredData ? ` da Fase ${getMonthNameFromString(activeStageObj?.title)}` : ''}
                {!loading && tasksByFilter?.length ? <em> ({tasksByFilter?.length})</em> : ''}
              </h2>

              {tasksByFilter && tasksByFilter?.length > 0 && <ExportButton data={tasksByFilter} />}
            </div>

            {!loading && filteredData && filteredData?.length > 0 && (
              <>
                <div className="w-full flex justify-end mb-3 space-x-3">
                  {Array.isArray(tasksStatus) && !!tasksStatus.length && (
                    <CustomSelect
                      placeholder="Filtrar por status"
                      className="w-[35%]"
                      options={
                        tasksStatus?.map(status => ({
                          label: `${status}${status !== 'Selecione' ? ` (${filteredData?.filter(x => !!x.statuses.includes(status)).length})` : ''}`,
                          value: status,
                        })) || []
                      }
                      onChange={(e: any) => setSelectedTasksStatus(e.value)}
                      aria-label="Filtrar realizações por status"
                    />
                  )}

                  <input
                    onChange={e => setSearchText(e.target.value)}
                    className={`text-white bg-maastricht-blue min-h-[38px] w-[35%] py-2 px-4 rounded-md leading-none text-sm font-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow`}
                    placeholder="Filtrar por texto"
                    aria-label="Filtrar realizações por texto"
                  />
                </div>
              </>
            )}

            <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px] space-y-6">
              {loading ? (
                <div className="grid grid-cols-1 gap-3">
                  <ArticlePlaceholder />
                </div>
              ) : tasksByFilter?.length ? (
                tasksByFilter?.map(item => (
                  <article
                    key={item._id}
                    aria-label={`Realização: ${item.title || item.description || item.result}`}
                    tabIndex={0}
                    className="focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow"
                  >
                    <TaskItem
                      editable={canEdit(item)}
                      bonus={
                        !!bonus?.hasBonus &&
                        !bonus?.isUsed &&
                        promotedTasks.length >= maxPromotedTasks &&
                        (!Array.isArray(item.prosseguir_managers) ||
                          !item.prosseguir_managers.length ||
                          !item.prosseguir_managers.includes(playerInfo._id))
                      }
                      promote={canPromote(item, item)}
                      double={canDouble(item)}
                      award={canAward(item)}
                      onClearStatus={(item: any, status: any) => console.log('remove status', status, item)}
                      data={item}
                      manager={gestor}
                      managerType={CheckManagerType({
                        user: { ...playerInfo, cod_etapa: userCodEtapa(playerInfo, !!item.mad) },
                        item,
                      })}
                      playerInfo={playerInfo}
                      canEvaluate={canEvaluate(item)}
                      onPromote={handlePromote}
                      onAccept={handleAccept}
                      onReject={handleReject}
                      onDouble={handleDoubled}
                      onStop={handleStop}
                      onFeedback={() => loadData(item._id)}
                      onReload={() => loadData(item._id)}
                      onAward={handleAward}
                      cycle={activeStageObj}
                      activeEvaluationStep={getActiveEvaluationStep}
                      taskStep={getTaskStep(item)}
                      playerStep={getPlayerStep(item)}
                      onReset={handleReset}
                      reset={canReset(item)}
                      getAction={getAction}
                      clearGetAction={() => setGetAction(null)}
                    />
                  </article>
                ))
              ) : (
                <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center" role="alert">
                  <img src={ImgFeedback} className="max-w-[150px]" alt="" />
                  <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                    {activeStageObj?._id === '68af4da8458e527eaa788503' ? (
                      <strong className="block text-center text-yellow font-semibold text-xl">
                        Não há Realizações Destaque nesta fase.
                      </strong>
                    ) : (
                      <>
                        {Array.isArray(filteredData) && filteredData.length && searchText?.length ? (
                          <strong className="block text-center text-yellow font-semibold text-xl">
                            Sem Realizações Destaque para esse filtro.
                          </strong>
                        ) : (
                          <strong className="block text-center text-yellow font-semibold text-xl">
                            Sua equipe
                            {activeStageObj?.status === 'open' ? ' ainda ' : ' '}não cadastrou Realizações Destaque nesta fase.
                          </strong>
                        )}
                      </>
                    )}
                  </p>
                </div>
              )}
            </Box>
          </div>
        </div>
      </main>

      {/* <ModalConclude callback={callBackConclude} /> */}

      <Outlet />

      {!!selectedGestor?.gestor && (
        <SelectGestor
          player={selectedGestor}
          closeModal={() => {
            setSelectedGestor(null);
            // loadData();
          }}
          onSubmit={(item: any) => {
            setSelectedGestor(null);
            functionsObject[functionGestor](selectedGestor.task, item._id);
          }}
        />
      )}

      {!!modalCod5?._id && (
        <ModalCod5
          task={modalCod5}
          playerInfo={playerInfo}
          onSubmit={handleSubmitCod5}
          onClose={() => setModalCod5(undefined)}
          award={canAward(modalCod5, true)}
          userCodEtapa={userCodEtapa()}
        />
      )}

      {/* {!loadBonus && canShowBonus && (!bonus || !bonus?.hasBonus) && <CardPlus onClose={() => getBonus()} />} */}
    </>
  );
}
